var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlterationEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 198,
    viewBox: "0 0 310 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9064 5.52421C15.6223 13.9553 -2.15081 39.3666 0.433936 59.0205C2.80246 77.0393 20.9869 80.3727 23.7443 100.779C26.8921 124.065 4.99269 132.901 9.73536 146.674C16.7132 166.939 65.527 151.882 134.869 179.423C150.642 185.687 158.037 190.407 174.161 192.723C200.891 196.563 208.08 187.542 244.579 185.188C282.725 182.728 298.868 191.033 305.897 181.121C312.164 172.281 300.726 163.7 300.97 137.531C301.17 116.051 308.955 113.401 309.717 92.3043C309.966 85.4437 310.771 63.1652 296.883 42.0797C284.435 23.1809 262.297 8.45482 238.748 6.15019C204.4 2.78729 198.75 28.9551 161.72 34.6226C105.994 43.152 78.9478 -10.0033 37.9064 5.52421Z",
    fill: "url(#paint0_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.701 67.2785C254.75 63.2138 253.354 58.9582 253.028 54.3265C252.208 42.6532 258.995 31.9034 263.982 21.8526C268.565 12.6158 271.972 -1.14879 256.507 0.0765071C244.187 1.05197 229.702 13.3274 228.05 26.1264C226.094 41.2749 233.471 60.3786 224.725 74.139C212.49 93.3887 203.664 88.9773 203.664 121.462C203.664 135.344 211.355 143 220.164 147.216C234.067 153.873 250.647 151.183 261.726 140.465C271.513 130.997 277.333 117.385 275.364 103.72C273.375 89.9177 262.546 79.4514 256.701 67.2785Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.366 171.725C246.172 171.725 245.996 171.594 245.947 171.398C238.283 140.813 234.11 113.089 233.547 88.9938C233.095 69.7006 234.944 52.6728 239.041 38.386C246.037 13.9839 257.011 6.14791 257.475 5.82649C257.67 5.69175 257.939 5.73947 258.075 5.93457C258.211 6.12966 258.162 6.39914 257.967 6.53388C257.856 6.61108 246.736 14.579 239.837 38.7383C233.46 61.0674 229.488 102.172 246.784 171.188C246.842 171.42 246.701 171.653 246.471 171.712C246.436 171.72 246.401 171.725 246.366 171.725Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.98 33.0287C268.385 32.8673 267.73 32.8167 267.033 32.8967C263.179 33.3403 261.595 37.4035 260.463 40.5798C259.493 43.2998 258.35 46.6024 258.923 49.5498C259.542 52.7359 262.927 55.3353 265.384 52.1001C268.177 48.4228 272.366 42.7763 272.392 37.9032C272.404 35.4821 271.044 33.5887 268.98 33.0287Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.51 147.423C299.087 137.041 295.311 125.121 293.427 114.142C292.432 108.337 291.97 102.576 292.904 96.7285C293.83 90.9136 296.564 84.6242 294.044 78.8318C288.965 67.1599 276.895 72.4723 269.981 81.2585C261.957 91.4539 259.764 108.115 256.716 120.945C254.878 128.68 252.111 136.613 251.142 144.494C249.537 157.55 252.49 166.615 258.737 172.736C264.73 178.607 273.856 179.826 281.187 175.744C287.808 172.056 294.966 164.172 297.51 147.423Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.895 195.633C269.688 195.633 269.506 195.484 269.471 195.273C269.444 195.116 266.82 179.281 266.751 157.429C266.688 137.255 268.852 107.671 279.519 81.3009C279.609 81.0806 279.86 80.9739 280.081 81.0623C280.301 81.1522 280.408 81.4034 280.319 81.6237C269.704 107.865 267.55 137.329 267.613 157.427C267.682 179.208 270.295 194.973 270.322 195.13C270.361 195.365 270.202 195.588 269.968 195.627C269.943 195.631 269.919 195.633 269.895 195.633Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8358 194.609C67.7149 200.574 25.344 143.597 37.1389 117.239C42.5653 105.113 57.887 102.975 58.2436 91.3494C58.6297 78.7526 40.8131 75.6662 38.3716 60.185C36.121 45.9193 47.673 25.8724 63.0326 25.05C74.9581 24.4099 87.3357 35.4573 89.4894 47.1671C92.6273 64.2244 72.32 73.1847 75.6882 88.5564C78.5551 101.637 94.5241 100.919 104.745 114.689C122.559 138.69 110.221 189.608 90.8358 194.609Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M61.2052 175.901C58.6232 173.261 56.2154 170.45 53.9648 167.513C53.3948 166.785 52.8557 166.033 52.3039 165.29C52.0315 164.917 51.7676 164.536 51.4994 164.159C51.2327 163.781 50.9631 163.404 50.7062 163.019C49.6574 161.494 48.6718 159.924 47.7044 158.343C45.795 155.166 44.0555 151.879 42.5532 148.477C41.8007 146.777 41.0902 145.055 40.4767 143.294L40.2422 142.635L40.0246 141.97C39.8814 141.527 39.7312 141.085 39.595 140.638L39.2005 139.294C39.0643 138.847 38.9604 138.39 38.8382 137.938C38.3791 136.124 37.9874 134.287 37.7417 132.418C37.4904 130.551 37.3767 128.658 37.4315 126.756C37.489 124.855 37.7249 122.944 38.2191 121.076C38.4578 120.141 38.7863 119.224 39.164 118.327C39.5613 117.439 40.005 116.565 40.5399 115.755C41.5929 114.121 42.8888 112.678 44.2843 111.398C44.9821 110.755 45.7009 110.146 46.4394 109.571C47.1709 108.987 47.9235 108.438 48.676 107.899C51.6763 105.731 54.7398 103.773 57.3751 101.227L57.7078 101.513C56.6226 103.034 55.2986 104.379 53.9283 105.638C53.2376 106.264 52.5299 106.865 51.8237 107.461C51.1175 108.059 50.3945 108.629 49.6911 109.214C48.2829 110.385 46.8859 111.541 45.6125 112.796C44.9723 113.419 44.3615 114.063 43.7971 114.739C43.2215 115.407 42.7048 116.111 42.2331 116.842C40.3181 119.745 39.515 123.275 39.3956 126.819C39.2847 130.377 39.7859 133.977 40.6382 137.49C40.7505 137.928 40.8445 138.371 40.9709 138.807L41.3359 140.116C41.4623 140.551 41.6027 140.983 41.7361 141.417L41.9397 142.067L42.1601 142.711C42.4465 143.573 42.761 144.426 43.0741 145.281C43.2327 145.708 43.4054 146.129 43.5697 146.553C43.7325 146.978 43.9066 147.399 44.085 147.817C45.4833 151.183 47.1274 154.449 48.902 157.645C52.5061 164.006 56.7251 170.043 61.5281 175.602L61.2052 175.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9014 28.3516C67.9348 28.5088 68.9541 28.753 69.9509 29.0716C70.9463 29.3958 71.9165 29.7916 72.8586 30.2492C74.7413 31.1657 76.5075 32.3208 78.1235 33.657C81.3372 36.3434 84.0118 39.7372 85.6587 43.6517C86.0631 44.6313 86.4099 45.6377 86.6654 46.6735C86.7805 47.1942 86.9012 47.7135 86.9658 48.2469L87.0824 49.0413L87.1357 49.8441C87.2171 50.915 87.1413 51.9915 87.0206 53.0568C86.9799 53.3221 86.9293 53.5846 86.8844 53.8484C86.8353 54.1123 86.7988 54.379 86.7257 54.6358C86.5952 55.1537 86.4758 55.6773 86.2975 56.1783C85.6447 58.2093 84.7054 60.1167 83.6454 61.9188C82.5896 63.7266 81.4313 65.4516 80.2688 67.1569C79.1091 68.8636 77.9522 70.5577 76.8936 72.3009C75.8392 74.0441 74.8831 75.8364 74.1418 77.706C73.4019 79.5741 72.8937 81.5264 72.7182 83.5139C72.5399 85.4985 72.6845 87.5126 73.1281 89.4677C73.5676 91.4215 74.3342 93.2924 75.4096 94.9795C76.4823 96.6707 77.8666 98.1599 79.4068 99.4764C80.9469 100.8 82.6598 101.931 84.4064 103.006C85.2796 103.545 86.1712 104.062 87.0613 104.583L89.7275 106.159L89.5099 106.539C87.6931 105.564 85.8623 104.616 84.0596 103.592C82.2611 102.566 80.4794 101.474 78.8424 100.159C77.2053 98.849 75.7185 97.3122 74.5349 95.5465C73.3443 93.7864 72.4963 91.7948 71.9951 89.733C71.4939 87.674 71.2875 85.5294 71.4602 83.4044C71.6259 81.2794 72.1481 79.1937 72.9063 77.2217C73.6616 75.2455 74.6472 73.3788 75.7241 71.5921C76.801 69.804 77.9663 68.086 79.1189 66.3765C80.2688 64.6656 81.4187 62.9687 82.452 61.2185C83.4881 59.4711 84.3867 57.6563 85.0031 55.7587C85.1729 55.2885 85.2824 54.8043 85.413 54.3242C85.4846 54.0856 85.5197 53.84 85.5675 53.5972C85.6124 53.353 85.6615 53.1102 85.7036 52.866C85.823 51.8849 85.9072 50.8954 85.8426 49.9073L85.8033 49.1662L85.7022 48.4293C85.6489 47.9367 85.5408 47.4497 85.4397 46.9626C85.2066 45.9928 84.9048 45.0384 84.5383 44.105C83.797 42.2411 82.7946 40.474 81.604 38.8417C81.0171 38.0178 80.3629 37.2445 79.689 36.4893C79.0052 35.7413 78.2765 35.0353 77.5198 34.3588C76.0007 33.0142 74.3342 31.8296 72.5385 30.8737C71.6413 30.3965 70.7119 29.9769 69.7572 29.626C68.8038 29.2709 67.8239 28.9832 66.8242 28.781L66.9014 28.3516Z",
    fill: "url(#paint1_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3419 48.3707C63.8372 59.9528 65.3928 71.5181 67.0467 83.0651C68.6837 94.6135 70.4893 106.132 72.4001 117.632C73.3674 123.379 74.4247 129.11 75.4804 134.842C76.0336 137.702 76.5728 140.566 77.1652 143.419C77.724 146.28 78.3305 149.129 78.9244 151.981L79.8651 156.249C80.1698 157.674 80.4941 159.094 80.8212 160.514C81.1512 161.933 81.4572 163.359 81.811 164.773L82.8345 169.023C84.2329 174.682 85.738 180.314 87.3259 185.934V185.935C87.3582 186.052 87.2908 186.173 87.1743 186.206C87.0633 186.237 86.9482 186.177 86.9089 186.07C84.89 180.582 83.0985 175.01 81.4263 169.403C80.6092 166.594 79.8117 163.779 79.0648 160.951C78.2828 158.13 77.5963 155.287 76.8858 152.448C74.1144 141.078 71.809 129.601 69.8083 118.077C69.3183 115.194 68.8143 112.314 68.3707 109.422C67.9031 106.535 67.4777 103.642 67.0565 100.75L66.4472 96.4072L65.8758 92.059L65.3254 87.7094C65.1401 86.2595 64.9674 84.8083 64.8059 83.3556L64.323 78.9976L63.861 74.6381C63.5676 71.73 63.3079 68.819 63.0481 65.9081C62.5652 60.0819 62.1285 54.253 61.9025 48.4072C61.8983 48.2865 61.9923 48.184 62.1131 48.1798C62.2268 48.1756 62.3251 48.2598 62.3391 48.3707H62.3419Z",
    fill: "url(#paint2_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.753 108.812H209.289V196.466H254.753V108.812Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.835 116.381H207.117V79.0471L249.334 76.8828L262.951 113.068C263.668 114.613 262.54 116.381 260.835 116.381Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.337 77.4301L209.285 79.5944V75.2658L246.711 73.1016C248.162 73.1016 249.337 74.2763 249.337 75.7262V77.4301Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.981 172.655H219.317C219.23 172.655 219.16 172.585 219.16 172.498V132.774C219.16 132.687 219.23 132.617 219.317 132.617H244.981C245.068 132.617 245.138 132.687 245.138 132.774V172.498C245.14 172.585 245.068 172.655 244.981 172.655Z",
    fill: "#E3EAFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.052 170.483H221.142C221.094 170.483 221.055 170.443 221.055 170.396V134.86C221.055 134.813 221.094 134.773 221.142 134.773H231.052C231.1 134.773 231.14 134.813 231.14 134.86V170.396C231.14 170.443 231.1 170.483 231.052 170.483Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.157 170.483H233.246C233.198 170.483 233.159 170.443 233.159 170.396V134.86C233.159 134.813 233.198 134.773 233.246 134.773H243.157C243.204 134.773 243.244 134.813 243.244 134.86V170.396C243.244 170.443 243.206 170.483 243.157 170.483Z",
    fill: "#BDD0FB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M215.72 96.6328H89.3945V196.459H215.72V96.6328Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.731 48.2109H89.3261L75.6541 95.1793C75.334 96.2769 75.5179 97.4559 76.1567 98.4131L77.5635 100.518C78.3132 101.641 79.5951 102.318 80.9696 102.318H220.686C222.275 102.318 223.717 101.417 224.38 100.01L225.732 97.1401C226.132 96.2909 226.209 95.3309 225.952 94.4312L212.731 48.2109Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.01 48.2087H88.9961V46.0795C88.9961 45.2739 89.6602 44.6184 90.4871 44.6058L211.473 42.8205C212.318 42.8079 213.01 43.4717 213.01 44.2942V48.2087Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.167 196.462H130V190.265C130 190.02 130.199 189.82 130.445 189.82H168.722C168.968 189.82 169.167 190.02 169.167 190.265V196.462Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.948 189.815H136.215V138.179C136.215 137.903 136.438 137.68 136.715 137.68H162.448C162.725 137.68 162.948 137.903 162.948 138.179V189.815Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.06 134.172H138.102C137.06 134.172 136.215 133.327 136.215 132.285V130.637C136.215 129.647 136.983 128.824 137.971 128.755L160.929 127.161C162.02 127.085 162.948 127.95 162.948 129.043V132.285C162.948 133.327 162.103 134.172 161.06 134.172Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.176 111.016H183.922C177.319 111.016 171.539 115.688 171.539 122.289V134.176H184.176V111.016Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.539 137.685V172.656C171.539 173.834 172.922 175.66 174.1 175.66H184.176V137.687H171.539V137.685Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.627 111.016H186.985V134.176H199.623V122.289C199.621 115.689 194.23 111.016 187.627 111.016Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.448 175.66C198.626 175.66 199.62 173.834 199.62 172.656V137.685H186.982V175.66H197.448Z",
    fill: "#BDD0FB"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.579 111.016H114.325C107.722 111.016 101.941 115.688 101.941 122.289V134.176H114.579V111.016Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.941 137.685V172.656C101.941 173.834 103.324 175.66 104.502 175.66H114.579V137.687H101.941V137.685Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.029 111.016H117.388V134.176H130.025V122.289C130.024 115.689 124.631 111.016 118.029 111.016Z",
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.85 175.66C129.028 175.66 130.022 173.834 130.022 172.656V137.685H117.385V175.66H127.85Z",
    fill: "#BDD0FB"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M123.687 96.7803H85.0674C84.1141 96.7803 83.2408 96.3423 82.6694 95.5802C82.0979 94.8167 81.9252 93.8553 82.1948 92.9415L93.2273 55.5117C93.2498 55.4345 93.3312 55.3896 93.4085 55.412C93.4857 55.4345 93.5306 55.5159 93.5081 55.5945L82.4756 93.0244C82.2327 93.8496 82.3886 94.717 82.9038 95.4048C83.4191 96.0925 84.2067 96.4883 85.0674 96.4883H123.687C123.768 96.4883 123.833 96.5543 123.833 96.6343C123.834 96.7157 123.768 96.7803 123.687 96.7803Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.866 175.807H141.831C140.486 175.807 139.391 174.712 139.391 173.367V143.549C139.391 142.204 140.486 141.109 141.831 141.109H145.866C147.211 141.109 148.306 142.204 148.306 143.549V173.367C148.306 174.713 147.212 175.807 145.866 175.807ZM141.832 141.403C140.649 141.403 139.685 142.366 139.685 143.549V173.367C139.685 174.55 140.649 175.513 141.832 175.513H145.867C147.051 175.513 148.014 174.55 148.014 173.367V143.549C148.014 142.366 147.051 141.403 145.867 141.403H141.832Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.128 175.807H153.092C151.747 175.807 150.652 174.712 150.652 173.367V143.549C150.652 142.204 151.747 141.109 153.092 141.109H157.128C158.473 141.109 159.568 142.204 159.568 143.549V173.367C159.568 174.713 158.473 175.807 157.128 175.807ZM153.092 141.403C151.909 141.403 150.946 142.366 150.946 143.549V173.367C150.946 174.55 151.909 175.513 153.092 175.513H157.128C158.311 175.513 159.274 174.55 159.274 173.367V143.549C159.274 142.366 158.311 141.403 157.128 141.403H153.092Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.866 185.856H141.831C140.486 185.856 139.391 184.761 139.391 183.417V179.986C139.391 178.642 140.486 177.547 141.831 177.547H145.866C147.211 177.547 148.306 178.642 148.306 179.986V183.417C148.306 184.761 147.212 185.856 145.866 185.856ZM141.832 177.84C140.649 177.84 139.685 178.803 139.685 179.986V183.417C139.685 184.6 140.649 185.563 141.832 185.563H145.867C147.051 185.563 148.014 184.6 148.014 183.417V179.986C148.014 178.803 147.051 177.84 145.867 177.84H141.832Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.128 185.856H153.092C151.747 185.856 150.652 184.761 150.652 183.417V179.986C150.652 178.642 151.747 177.547 153.092 177.547H157.128C158.473 177.547 159.568 178.642 159.568 179.986V183.417C159.568 184.761 158.473 185.856 157.128 185.856ZM153.092 177.84C151.909 177.84 150.946 178.803 150.946 179.986V183.417C150.946 184.6 151.909 185.563 153.092 185.563H157.128C158.311 185.563 159.274 184.6 159.274 183.417V179.986C159.274 178.803 158.311 177.84 157.128 177.84H153.092Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.716 177.843H170.296C168.552 177.843 167.133 176.424 167.133 174.68V122.029C167.133 113.703 173.908 106.93 182.238 106.93H188.775C197.104 106.93 203.879 113.703 203.879 122.029V174.68C203.879 176.424 202.46 177.843 200.716 177.843ZM182.238 107.222C174.071 107.222 167.426 113.865 167.426 122.029V174.68C167.426 176.262 168.714 177.549 170.296 177.549H200.715C202.297 177.549 203.585 176.262 203.585 174.68V122.029C203.585 113.865 196.939 107.222 188.772 107.222H182.238Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.129 177.843H100.71C98.9663 177.843 97.5469 176.424 97.5469 174.68V122.029C97.5469 113.703 104.323 106.93 112.651 106.93H119.188C127.516 106.93 134.293 113.703 134.293 122.029V174.68C134.292 176.424 132.874 177.843 131.129 177.843ZM112.651 107.222C104.484 107.222 97.8389 113.865 97.8389 122.029V174.68C97.8389 176.262 99.1264 177.549 100.709 177.549H131.127C132.71 177.549 133.997 176.262 133.997 174.68V122.029C133.997 113.865 127.352 107.222 119.185 107.222H112.651Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.953 85.8321C216.89 85.8321 216.832 85.7914 216.812 85.7283L208.233 57.3822C207.646 55.4453 205.893 54.133 203.87 54.1175C181.408 53.9407 167.654 53.9477 167.079 54.1358C167.003 54.1611 166.919 54.1232 166.892 54.0488C166.865 53.9744 166.898 53.8944 166.971 53.8635C167.659 53.58 190.386 53.7175 203.873 53.8242C206.025 53.841 207.89 55.2376 208.513 57.2966L217.093 85.6427C217.117 85.7199 217.073 85.8013 216.995 85.8251C216.981 85.8293 216.967 85.8321 216.953 85.8321Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.922 187.364C214.922 187.364 223.046 150.804 212.122 155.835C201.198 160.865 211.017 186.387 212.122 187.983C213.227 189.579 214.283 190.495 214.922 187.364Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.104 188.369C214.104 188.369 210.561 163.069 220.695 165.004C230.828 166.94 215.481 188.157 215.383 189.069C215.284 189.983 214.104 188.369 214.104 188.369Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.806 188.497C212.806 188.497 210.396 165.978 202.607 169.626C194.818 173.274 211.649 188.584 211.918 189.352C212.188 190.12 212.806 188.497 212.806 188.497Z",
    fill: "#91B3FA"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.614 159.962C215.552 159.962 215.494 159.921 215.476 159.86C215.152 158.772 214.614 158.041 213.878 157.687C212.839 157.187 211.751 157.617 211.74 157.621C211.667 157.65 211.583 157.615 211.553 157.541C211.524 157.468 211.559 157.384 211.632 157.354C211.681 157.335 212.851 156.874 214.003 157.429C214.815 157.819 215.403 158.61 215.753 159.778C215.775 159.854 215.732 159.934 215.656 159.956C215.642 159.961 215.628 159.962 215.614 159.962Z",
    fill: "url(#paint3_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.617 185.023C215.59 185.023 215.563 185.016 215.538 185.001C215.472 184.957 215.452 184.869 215.496 184.801C215.534 184.741 219.386 178.763 221.93 173.245C222.721 171.531 222.836 170.033 222.276 168.793C221.432 166.927 219.319 166.279 219.298 166.273C219.222 166.251 219.179 166.171 219.201 166.095C219.223 166.019 219.303 165.976 219.379 165.998C219.471 166.026 221.64 166.69 222.537 168.675C223.134 169.994 223.017 171.573 222.191 173.365C219.639 178.902 215.777 184.898 215.737 184.957C215.711 185.001 215.664 185.023 215.617 185.023Z",
    fill: "url(#paint4_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.758 184.961C210.689 184.961 210.628 184.912 210.616 184.843C210.612 184.82 210.151 182.337 207.919 175.566C207.059 172.958 205.911 171.357 204.597 170.934C203.455 170.567 202.557 171.208 202.548 171.214C202.484 171.261 202.394 171.246 202.348 171.183C202.301 171.118 202.315 171.028 202.379 170.982C202.419 170.953 203.398 170.249 204.68 170.659C206.106 171.115 207.288 172.736 208.192 175.476C210.433 182.274 210.895 184.769 210.899 184.793C210.913 184.872 210.861 184.946 210.783 184.96C210.774 184.961 210.766 184.961 210.758 184.961Z",
    fill: "url(#paint5_linear_4296_17492)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.324 187.28L208.531 195.151C208.871 196.362 209.97 197.202 211.228 197.211L216.214 197.249C217.645 197.261 218.858 196.2 219.036 194.779L220.075 186.523L206.324 187.28Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.88 185.953L206.187 186.195C205.519 186.206 204.984 186.791 204.988 187.501C204.993 188.212 205.536 188.781 206.203 188.774L219.883 188.644C220.612 188.637 221.206 188.026 221.206 187.281C221.203 186.536 220.609 185.941 219.88 185.953Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7501 101.805C53.9414 103.348 48.0742 97.672 43.7162 94.2445C37.9641 89.7195 33.5977 92.0564 33.5977 92.0564L39.8651 103.905C49.0542 112.561 58.2671 110.426 64.0445 107.456C64.0923 105.143 63.4605 103.222 62.7501 101.805Z",
    fill: "#0170B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0644 96.1016L72.1651 97.7928C68.6931 100.079 65.572 101.312 62.75 101.804C63.4604 103.22 64.0922 105.143 64.0459 107.455C67.7243 105.564 70.01 103.335 70.01 103.335C76.5695 99.1052 75.0644 96.1016 75.0644 96.1016Z",
    fill: "#0170B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0665 178.741L41.4151 182.12C40.2961 187.915 42.5579 193.226 46.4666 193.98L51.1138 194.876C55.0225 195.63 59.0997 191.543 60.2187 185.748L60.8701 182.369C60.9137 182.146 60.9516 181.922 60.9853 181.696L75.9925 80.7272L65.8669 78.7734L42.2111 178.073C42.1578 178.295 42.1101 178.517 42.0665 178.741ZM46.8232 179.383C47.6656 175.019 50.4511 171.888 53.0443 172.387C55.6375 172.888 57.0583 176.831 56.2159 181.195C55.3735 185.558 52.588 188.69 49.9949 188.19C47.4017 187.69 45.9808 183.746 46.8232 179.383Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3662 43.5698L63.5825 63.169C63.3129 64.5641 63.7074 66.0055 64.6481 67.0708L69.4736 72.5292C70.8509 74.0872 73.1057 74.5223 74.9646 73.5889L81.4763 70.3158C82.7469 69.6772 83.6483 68.487 83.9178 67.0905L87.7016 47.4913C88.2716 44.5355 92.0848 43.5824 93.9241 45.9657C98.3256 51.6683 100.345 59.2952 98.8394 67.0933C96.1185 81.1877 83.2538 88.7613 69.6926 86.1451C56.1315 83.5289 47.0098 71.7124 49.7307 57.6179C51.2358 49.8198 55.9504 43.4926 62.1574 39.8364C64.752 38.3107 67.9363 40.6139 67.3662 43.5698Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2178 43.9285L65.434 63.5277C65.1645 64.9228 65.559 66.3643 66.4997 67.4295L71.3252 72.888C72.7025 74.4459 74.9573 74.881 76.8162 73.9476L83.3279 70.676C84.5985 70.0373 85.4998 68.8471 85.7694 67.4506L89.5532 47.8514C90.1232 44.8956 93.9364 43.9426 95.7756 46.3258C100.177 52.0284 102.196 59.6553 100.691 67.4534C97.9701 81.5479 85.1053 89.1214 71.5442 86.5052C57.9831 83.889 48.8614 72.0725 51.5823 57.9781C53.0874 50.1799 57.802 43.8527 64.009 40.1965C66.605 38.6694 69.7892 40.9726 69.2178 43.9285Z",
    fill: "#1A3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5392 179.023L42.8877 182.401C41.7688 188.198 44.0306 193.507 47.9393 194.261L52.5865 195.158C56.4952 195.911 60.5724 191.824 61.6914 186.029L62.3428 182.651C62.3863 182.428 62.4242 182.203 62.4579 181.977L77.4652 81.0084L67.3396 79.0547L43.6838 178.354C43.6304 178.576 43.5827 178.799 43.5392 179.023ZM48.2959 179.665C49.1383 175.302 51.9238 172.17 54.517 172.67C57.1101 173.171 58.531 177.114 57.6886 181.477C56.8462 185.841 54.0607 188.972 51.4675 188.473C48.8729 187.972 47.4535 184.029 48.2959 179.665Z",
    fill: "#1A3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4484 100.474C75.5565 99.8406 75.3712 99.1978 74.9514 98.7121C74.1371 97.7704 72.7303 96.4805 71.7096 97.3507C70.1905 98.6462 71.8556 103.074 71.8556 103.074L73.5404 105.646L73.5643 107.288C74.4755 106.22 75.0202 103.595 75.4484 100.474Z",
    fill: "url(#paint6_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6458 121.695C16.3808 123.097 14.5036 124.323 13.1797 125.09C15.2239 127.521 17.9729 129.941 21.5966 132.292L22.6636 134.57L25.8703 130.577C25.8689 130.578 19.9273 127.76 17.6458 121.695Z",
    fill: "url(#paint7_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6107 195.92C36.6107 195.85 36.605 195.778 36.5854 195.707C35.4425 191.516 30.12 188.992 30.12 188.992L28.0337 189.196C26.9021 192.931 27.1 195.204 27.312 196.215C27.3177 196.243 27.3275 196.27 27.3345 196.298C29.06 196.418 32.6107 196.452 36.6107 195.92Z",
    fill: "#1A3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.332 196.29C27.4317 196.627 27.6858 196.885 28.0073 196.947C30.4699 197.416 34.359 196.927 35.9918 196.683C36.3527 196.63 36.6096 196.29 36.6082 195.914C32.6096 196.446 29.0589 196.412 27.332 196.29Z",
    fill: "url(#paint8_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1328 186.095L28.0988 190.338C28.169 190.648 28.4132 190.878 28.7053 190.9C29.0619 190.926 29.5687 190.936 30.0756 190.852C30.5305 190.776 30.8407 190.306 30.7495 189.81L30.0629 186.039L27.1328 186.095Z",
    fill: "url(#paint9_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6618 195.906C43.3522 195.885 42.1532 195.635 41.5312 195.395C41.5341 195.624 41.5397 195.859 41.5523 196.1C41.5649 196.358 41.7601 196.56 41.996 196.555L54.667 196.233C55.0713 196.224 55.2988 195.749 55.1162 195.383C53.4567 195.553 49.2307 195.94 45.6618 195.906Z",
    fill: "url(#paint10_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1153 195.38C55.0999 195.347 55.0859 195.315 55.0634 195.286C53.9149 193.743 51.0059 190.683 45.3464 189.44L42.6423 189.406C42.6423 189.406 41.4784 191.52 41.5289 195.392C42.1509 195.632 43.3499 195.882 45.6595 195.903C49.2298 195.936 53.4558 195.548 55.1153 195.38Z",
    fill: "#1A3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0664 185.315C42.1001 185.516 42.5283 188.57 42.694 189.753C42.7333 190.034 42.9411 190.249 43.1994 190.275C43.6599 190.322 44.4055 190.358 45.0555 190.212C45.4051 190.134 45.6536 189.791 45.6466 189.398L45.5553 184.594L42.0664 185.315Z",
    fill: "url(#paint11_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8472 129.508C38.8472 129.508 45.8321 154.146 46.3038 185.307C46.3122 185.876 45.9233 186.373 45.3688 186.5C44.5531 186.688 43.3512 186.916 42.3544 186.907C41.8223 186.903 41.3688 186.516 41.2691 185.994C40.254 180.653 34.4401 150.571 31.3584 145.727C31.3584 145.727 29.8996 172.646 30.7926 186.579C30.815 186.926 30.5665 187.232 30.2225 187.278C29.7003 187.348 28.8649 187.41 27.7965 187.317C27.3907 187.282 27.0594 186.983 26.9934 186.582C26.2563 182.06 22.0008 155.141 21.793 135.696C21.7818 134.6 24.5827 129.777 24.5827 129.777L38.8472 129.508Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3439 99.3722C46.2614 98.0669 45.3081 96.6633 44.505 95.2135C43.3832 93.1895 44.4432 96.5384 44.1035 94.2352C35.8859 88.5396 23.7344 91.7298 19.0226 92.4148C17.4782 92.6393 16.0757 93.4281 15.0788 94.6282C11.121 99.3862 2.48365 112.369 13.1792 125.087C14.5032 124.319 16.3803 123.094 17.6453 121.691C16.4281 118.455 16.254 114.293 18.5804 109.141C18.6702 109.544 18.7811 109.942 18.9131 110.335C22.4526 120.849 22.7965 129.648 22.8274 131.678C22.8316 131.953 23.0015 132.198 23.2599 132.295C27.688 133.972 36.1302 132.765 38.9621 132.288C39.4815 132.201 39.8227 131.71 39.7413 131.189C38.1562 121.12 44.9964 104.376 46.8075 100.181C46.9381 99.8803 47.1206 99.608 47.3439 99.3722Z",
    fill: "#0170B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4572 83.7679L25.7734 92.4363C25.7734 92.4363 30.6705 93.8103 34.1637 91.2461L31.5256 83.4297L26.4572 83.7679Z",
    fill: "url(#paint12_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9254 73.7922C32.0447 73.9003 37.0527 83.2886 37.0527 83.2886L31.6305 86.0325L25.5625 77.84C25.5611 77.84 29.9289 71.983 31.9254 73.7922Z",
    fill: "url(#paint13_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.983 78.0288C27.8903 78.2829 27.9198 78.565 28.063 78.7938L30.878 83.2908C30.9201 83.3595 30.9707 83.4199 31.031 83.4746C31.361 83.7708 32.4898 84.6297 33.3266 83.4157C34.0398 82.3813 34.7095 81.4409 35.4382 81.0437C35.8636 80.8121 36.3971 80.9805 36.6231 81.4086C37.0892 82.2914 37.9948 84.0908 38.5747 85.8031C38.7193 86.2326 38.5059 86.7 38.0889 86.8782C36.9896 87.3484 34.8148 88.2004 32.8759 88.5063C32.5572 88.5569 32.2385 88.4277 32.0433 88.1709C31.1855 87.041 28.7678 83.8859 27.9493 83.0999C27.1883 82.37 25.8138 82.676 25.1961 82.8669C24.9616 82.9399 24.7103 82.9118 24.4969 82.7883C23.8595 82.4206 22.7405 81.4956 23.7177 79.8759C23.9606 79.4731 23.823 78.9454 23.4256 78.6941C22.7124 78.245 21.9332 77.3902 22.6338 75.9684C23.3442 74.5298 24.6569 74.3768 25.5555 74.4694C25.9528 74.5102 26.3515 74.2954 26.4962 73.9235C26.5607 73.7578 26.6913 73.6161 26.9398 73.56C27.4073 73.4561 27.7078 73.021 27.6067 72.5522C27.434 71.7494 27.5323 70.6995 28.8071 69.9683C31.1434 68.6265 33.2521 70.7009 33.8123 72.4764C34.3725 74.2519 31.7555 75.5628 30.0988 75.8056C28.8829 75.9853 28.2399 77.3285 27.983 78.0288Z",
    fill: "#1A3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0096 84.7542C29.0096 84.7542 27.9018 81.7029 26.5596 81.8405C25.2174 81.978 24.1855 83.3366 25.8787 84.8104C27.9861 86.6434 29.0096 84.7542 29.0096 84.7542Z",
    fill: "url(#paint14_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M18.1225 108.362C16.2594 103.549 16.7915 97.6839 16.7972 97.625L17.2857 97.6713C17.2801 97.7289 16.7593 103.481 18.5802 108.184L18.1225 108.362Z",
    fill: "#19154E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.102 145.099C30.9925 145.101 30.8914 145.03 30.8605 144.92C30.2807 142.847 26.1909 140.632 26.1487 140.611C26.0294 140.546 25.9845 140.397 26.0491 140.278C26.1137 140.159 26.2611 140.114 26.3818 140.177C26.5573 140.271 30.6977 142.513 31.3337 144.788C31.3702 144.918 31.2944 145.054 31.1638 145.091C31.1441 145.095 31.1231 145.099 31.102 145.099Z",
    fill: "url(#paint15_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7403 70.9474L22.204 80.7077C22.0229 80.848 21.7576 80.7413 21.7239 80.514L21.5933 79.6199C21.5933 79.6199 16.3761 74.3762 21.7365 69.6351C27.0969 64.8939 33.4205 70.2652 33.4205 70.2652L34.6336 70.5053C34.8456 70.546 34.9101 70.8154 34.7403 70.9474Z",
    fill: "#0170B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.972 194.812L254.017 111.988C253.775 111.524 253.958 110.948 254.423 110.708C254.887 110.467 255.463 110.649 255.703 111.114L298.658 193.937C298.9 194.402 298.717 194.977 298.252 195.217C298.118 195.287 297.966 195.324 297.816 195.324C297.46 195.324 297.136 195.127 296.972 194.812Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.568 195.452L239.852 111.118C239.643 110.638 239.864 110.077 240.345 109.868C240.825 109.659 241.387 109.881 241.596 110.359L278.312 194.693C278.413 194.926 278.417 195.184 278.325 195.42C278.232 195.656 278.052 195.842 277.819 195.943C277.698 195.995 277.571 196.022 277.44 196.022C277.061 196.023 276.718 195.799 276.568 195.452Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.66 127.172H262.552C262.881 127.172 263.146 126.907 263.146 126.578C263.146 126.25 262.881 125.984 262.552 125.984H247.66C247.332 125.984 247.066 126.25 247.066 126.578C247.066 126.907 247.332 127.172 247.66 127.172Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.641 136.391H266.533C266.861 136.391 267.127 136.125 267.127 135.797C267.127 135.468 266.861 135.203 266.533 135.203H251.641C251.312 135.203 251.047 135.468 251.047 135.797C251.047 136.124 251.314 136.391 251.641 136.391Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.887 147.437H272.728C273.057 147.437 273.322 147.172 273.322 146.844C273.322 146.515 273.057 146.25 272.728 146.25H256.887C256.558 146.25 256.293 146.515 256.293 146.844C256.293 147.172 256.558 147.437 256.887 147.437Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.707 118.226H257.916C258.244 118.226 258.509 117.961 258.509 117.633C258.509 117.304 258.244 117.039 257.916 117.039H243.707C243.379 117.039 243.113 117.304 243.113 117.633C243.113 117.96 243.38 118.226 243.707 118.226Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.113 160.148H279.325C279.653 160.148 279.919 159.883 279.919 159.555C279.919 159.226 279.653 158.961 279.325 158.961H262.113C261.785 158.961 261.52 159.226 261.52 159.555C261.52 159.883 261.786 160.148 262.113 160.148Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.16 170H284.621C284.95 170 285.215 169.735 285.215 169.406C285.215 169.078 284.95 168.812 284.621 168.812H266.16C265.832 168.812 265.566 169.078 265.566 169.406C265.566 169.735 265.832 170 266.16 170Z",
    fill: "#7D97F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.856 118.891C282.548 119.629 283.566 120.268 284.284 120.665C283.213 121.988 281.765 123.313 279.847 124.609L279.298 125.84L277.539 123.733C277.539 123.734 280.694 122.164 281.856 118.891Z",
    fill: "url(#paint16_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.402 138.168C278.089 138.979 279.31 139.065 280.104 138.359L282.394 136.321C283.188 135.613 283.243 134.392 282.516 133.616L247.058 96.0781L244.195 98.627L277.402 138.168ZM274.225 131.942C272.323 129.805 271.333 127.582 272.015 126.974C272.698 126.367 274.792 127.606 276.696 129.742C278.599 131.878 279.588 134.102 278.906 134.709C278.222 135.317 276.128 134.076 274.225 131.942Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.195 98.627L247.058 96.0781L257.608 107.336L254.164 110.401L244.195 98.627Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.896 107.095L256.422 88.8212C257.028 88.2822 257.082 87.3531 256.541 86.7481L255.248 85.2969L232.527 105.525L233.82 106.976C234.361 107.581 235.29 107.636 235.896 107.095Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.528 105.521L255.248 85.2929C249.456 79.005 244.575 72.581 241.692 65.8594L237.575 69.524L236.984 74.3298L233.541 73.1157L228.237 77.8387L227.403 82.0493L224.981 80.7384L218.602 86.4186C219.933 92.6784 225.884 99.0884 232.528 105.521Z",
    fill: "#B0DBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.586 102.607C226.003 95.4703 221.545 87.5627 221.5 87.4841L221.751 87.3438C221.795 87.4223 226.234 95.2921 233.782 102.398L233.586 102.607Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.853 101.484C228.372 95.7697 223.034 86.2592 222.98 86.1638L223.232 86.0234C223.285 86.1189 228.599 95.5858 235.044 101.267L234.853 101.484Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.579 95.5158C234.19 90.0083 229.98 80.0543 229.938 79.9546L230.203 79.8438C230.245 79.9434 234.426 89.8258 241.751 95.2856L241.579 95.5158Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.344 93.9416C236.282 88.7289 231.705 78.5236 231.66 78.4212L231.923 78.3047C231.968 78.4057 236.514 88.5422 243.514 93.71L243.344 93.9416Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.228 87.7816C242.945 80.0172 239.998 71.8331 239.969 71.7517L240.24 71.6562C240.269 71.7377 243.198 79.867 250.437 87.5865L250.228 87.7816Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.445 158.863C272.445 158.825 272.447 158.787 272.457 158.749C273.027 156.491 275.853 155.086 275.853 155.086L276.973 155.174C277.618 157.165 277.535 158.384 277.431 158.929C277.428 158.944 277.424 158.958 277.42 158.974C276.496 159.054 274.595 159.107 272.445 158.863Z",
    fill: "#1A3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.421 158.966C277.371 159.147 277.237 159.289 277.066 159.325C275.752 159.602 273.661 159.379 272.784 159.265C272.59 159.24 272.448 159.06 272.445 158.859C274.595 159.102 276.496 159.049 277.421 158.966Z",
    fill: "url(#paint17_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.423 153.5L276.949 155.784C276.914 155.951 276.786 156.077 276.63 156.091C276.439 156.109 276.168 156.119 275.894 156.08C275.65 156.043 275.479 155.795 275.522 155.528L275.852 153.5H277.423Z",
    fill: "url(#paint18_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.596 158.949C268.833 158.914 269.473 158.769 269.805 158.633C269.806 158.756 269.805 158.881 269.8 159.01C269.796 159.149 269.694 159.26 269.567 159.259L262.773 159.215C262.557 159.214 262.429 158.963 262.524 158.763C263.415 158.838 265.684 159.003 267.596 158.949Z",
    fill: "url(#paint19_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.516 158.765C262.524 158.748 262.531 158.73 262.542 158.715C263.142 157.877 264.671 156.208 267.689 155.484L269.138 155.438C269.138 155.438 269.783 156.559 269.795 158.635C269.464 158.77 268.824 158.916 267.587 158.951C265.676 159.004 263.407 158.838 262.516 158.765Z",
    fill: "#1A3860"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.412 153.242C269.397 153.35 269.197 154.99 269.12 155.626C269.102 155.778 268.993 155.894 268.855 155.911C268.608 155.941 268.209 155.967 267.859 155.896C267.671 155.856 267.535 155.677 267.535 155.466V152.891L269.412 153.242Z",
    fill: "url(#paint20_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.573 123.298C270.573 123.298 267.078 136.572 267.141 153.275C267.143 153.58 267.356 153.842 267.655 153.905C268.095 153.998 268.741 154.108 269.276 154.092C269.561 154.084 269.799 153.873 269.847 153.591C270.337 150.719 273.148 134.539 274.75 131.913C274.75 131.913 275.804 146.324 275.467 153.8C275.459 153.986 275.595 154.147 275.78 154.169C276.061 154.202 276.509 154.227 277.08 154.165C277.296 154.143 277.472 153.978 277.503 153.762C277.852 151.331 279.86 136.864 279.775 126.441C279.77 125.853 278.22 123.297 278.22 123.297H270.573V123.298Z",
    fill: "#004ABA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.711 107.239C266.278 106.529 266.775 105.766 267.191 104.982C267.771 103.886 268.606 102.999 268.765 101.761C272.696 101.62 278.285 102.906 280.816 103.225C281.646 103.328 282.406 103.738 282.952 104.371C285.121 106.881 289.881 113.751 284.279 120.675C283.561 120.278 282.543 119.639 281.851 118.901C282.47 117.153 282.522 114.922 281.222 112.185C281.177 112.402 281.123 112.617 281.057 112.828C279.266 118.498 279.171 123.217 279.175 124.304C279.175 124.452 279.087 124.585 278.951 124.64C276.595 125.585 272.058 125.022 270.535 124.796C270.256 124.754 270.068 124.494 270.107 124.215C270.854 118.803 267.019 109.898 266.006 107.67C265.933 107.507 265.833 107.362 265.711 107.239Z",
    fill: "#0170B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.746 98.0133L277.2 102.652C277.2 102.652 274.59 103.438 272.691 102.099L274.027 97.8828L276.746 98.0133Z",
    fill: "url(#paint21_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.466 111.759C282.415 109.161 282.071 106.023 282.067 105.992L281.806 106.022C281.808 106.053 282.147 109.129 281.219 111.668L281.466 111.759Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.878 131.577C274.937 131.577 274.99 131.537 275.006 131.478C275.295 130.361 277.466 129.133 277.487 129.122C277.55 129.087 277.572 129.005 277.537 128.942C277.502 128.879 277.422 128.856 277.358 128.892C277.265 128.943 275.068 130.187 274.75 131.412C274.732 131.483 274.774 131.554 274.844 131.572C274.857 131.575 274.868 131.577 274.878 131.577Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.318 107.446C260.234 108.182 263.438 105.082 265.825 103.201C268.976 100.718 271.429 101.927 271.429 101.927L268.068 108.34C263.049 113.071 257.902 112.02 254.657 110.487C254.608 109.249 254.939 108.212 255.318 107.446Z",
    fill: "#0170B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.507 103.32L250.041 105.391C251.995 106.581 253.744 107.21 255.32 107.445C254.939 108.212 254.608 109.248 254.658 110.487C252.593 109.511 251.299 108.339 251.299 108.339C247.605 106.139 248.507 103.32 248.507 103.32Z",
    fill: "url(#paint22_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.033 93.9062C273.033 93.9062 271.059 97.62 271.311 99.1204C271.564 100.621 274.011 100.513 276.147 99.2945L277.639 95.2845L273.033 93.9062Z",
    fill: "url(#paint23_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.051 97.3262C275.964 97.2883 275.932 97.1816 275.984 97.1016C276.142 96.8602 276.438 96.3676 276.533 95.9367C276.533 95.9367 276.888 95.7093 275.63 95.4089C274.372 95.1086 272.496 94.6412 272.102 93.5703C271.717 92.526 273.779 91.1716 275.391 93.2629C275.453 93.3429 274.521 92.0741 274.582 91.9941C274.846 91.6502 275.541 90.9372 276.506 91.3695C277.409 91.7737 277.51 92.4348 277.497 92.7689C277.493 92.8671 277.581 92.9429 277.677 92.9246C278.133 92.8376 279.228 92.7632 279.739 93.8861C280.16 94.811 279.887 95.3345 279.637 95.59C279.555 95.6728 279.592 95.8089 279.703 95.844C280.003 95.9353 279.902 95.7893 279.863 96.4911C279.809 97.4623 279.211 97.7767 278.902 97.7332C278.852 97.7262 278.801 97.743 278.766 97.7809C278.501 98.0743 277.308 99.3192 276.014 99.4694C275.902 99.482 275.817 99.3726 275.853 99.2659L276.412 97.6406C276.438 97.5648 276.402 97.482 276.329 97.4497L276.051 97.3262Z",
    fill: "#172445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83 97.5554C275.83 97.5554 277.235 96.5911 277.338 97.4038C277.44 98.2151 276.073 98.58 275.395 98.2768L275.83 97.5554Z",
    fill: "url(#paint24_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.289 92.4777L279.626 98.7193L279.484 98.1536C279.484 98.1536 282.88 94.5732 279.532 91.7226C276.183 88.8719 272.36 92.2447 272.36 92.2447L271.289 92.4777Z",
    fill: "#0170B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9569 87.8511L57.4202 87.1227C57.4637 87.0539 57.555 87.0343 57.6238 87.0778C57.6926 87.1213 57.7136 87.2125 57.6687 87.2813L57.6673 87.2827L57.197 88.0069C57.1535 88.0729 57.065 88.0925 56.9976 88.049C56.933 88.0069 56.9134 87.9185 56.9569 87.8511Z",
    fill: "url(#paint25_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5532 85.4478L59.0559 84.7474C59.1078 84.6744 59.2089 84.6576 59.2819 84.7109C59.3549 84.7628 59.3718 84.8639 59.3184 84.9369L59.317 84.9383L58.8073 85.6344C58.7554 85.7046 58.6571 85.7201 58.5869 85.6681C58.5181 85.6162 58.5027 85.5179 58.5532 85.4478Z",
    fill: "url(#paint26_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2761 83.1361L60.8166 82.4638C60.877 82.388 60.9879 82.3768 61.0637 82.4371C61.1395 82.4975 61.1508 82.6084 61.0904 82.6842L61.089 82.6856L60.5428 83.3523C60.4825 83.4252 60.3744 83.4365 60.3014 83.3761C60.2283 83.3172 60.2171 83.2091 60.2761 83.1361Z",
    fill: "url(#paint27_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1252 80.9227L62.7008 80.2813C62.771 80.2041 62.8904 80.1971 62.9676 80.2673C63.0448 80.3375 63.0518 80.4568 62.9816 80.534L62.9802 80.5354L62.399 81.1726C62.3302 81.2484 62.2122 81.2526 62.1378 81.1838C62.0634 81.1136 62.0578 80.9971 62.1252 80.9227Z",
    fill: "url(#paint28_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0899 78.8112L64.6978 78.2006C64.7764 78.1206 64.9056 78.1206 64.9856 78.2006C65.0656 78.2792 65.0656 78.4083 64.9856 78.4869L64.9842 78.4884L64.3693 79.0933C64.2906 79.1705 64.1657 79.1691 64.0885 79.0905C64.0112 79.0133 64.0127 78.8884 64.0899 78.8112Z",
    fill: "url(#paint29_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1591 76.8059L66.798 76.2276C66.8864 76.1476 67.024 76.1546 67.104 76.243C67.1841 76.3315 67.177 76.469 67.0886 76.549L67.0872 76.5504L66.4428 77.1231C66.3543 77.2003 66.2209 77.1932 66.1423 77.1048C66.0665 77.0178 66.0735 76.8845 66.1591 76.8059Z",
    fill: "url(#paint30_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3339 74.9025L69.0008 74.3565C69.0991 74.2765 69.2451 74.2906 69.3252 74.3888C69.4052 74.487 69.3911 74.633 69.2929 74.713L69.2915 74.7144L68.619 75.2534C68.5221 75.332 68.3789 75.3165 68.3003 75.2183C68.2216 75.1229 68.2371 74.9811 68.3339 74.9025Z",
    fill: "url(#paint31_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.597 73.1227L71.2906 72.6104C71.3987 72.5304 71.5518 72.5529 71.6318 72.6609C71.7118 72.769 71.6893 72.922 71.5812 73.002L71.5798 73.0034L70.8821 73.5101C70.7754 73.5887 70.6251 73.5634 70.5465 73.4567C70.4679 73.3501 70.4917 73.2013 70.597 73.1227Z",
    fill: "url(#paint32_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.945 71.4459L73.6611 70.9659C73.779 70.8859 73.9405 70.9182 74.0191 71.0361C74.0991 71.154 74.0668 71.3154 73.9475 71.394L73.9461 71.3954L73.2244 71.8684C73.1065 71.9456 72.9492 71.9119 72.872 71.7954C72.7976 71.6803 72.8299 71.5231 72.945 71.4459Z",
    fill: "url(#paint33_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3677 69.876L76.1062 69.4297C76.2353 69.3525 76.4024 69.3932 76.4796 69.5209C76.5569 69.6501 76.5161 69.8171 76.3884 69.8943L76.3856 69.8957L75.6429 70.335C75.5151 70.4108 75.3508 70.3687 75.2764 70.2409C75.2006 70.1146 75.2413 69.9518 75.3677 69.876Z",
    fill: "url(#paint34_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8611 68.4241L78.6178 68.0115C78.7568 67.9357 78.9295 67.9876 79.0053 68.1252C79.0811 68.2627 79.0306 68.4368 78.8916 68.5125L78.8888 68.5139L78.1278 68.9196C77.9902 68.9926 77.8204 68.9406 77.7474 68.8031C77.6757 68.6669 77.7263 68.4985 77.8611 68.4241Z",
    fill: "url(#paint35_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4191 67.0751L81.1927 66.6948C81.3415 66.6218 81.5212 66.6835 81.5942 66.8309C81.6672 66.9797 81.6055 67.1593 81.4581 67.2323L81.4552 67.2337L80.6774 67.6057C80.53 67.6758 80.3545 67.6141 80.2829 67.4667C80.2127 67.3208 80.2745 67.1453 80.4191 67.0751Z",
    fill: "url(#paint36_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0245 65.85L83.8135 65.5033C83.9721 65.4331 84.1575 65.5061 84.2263 65.6633C84.2965 65.8219 84.2235 66.0058 84.0662 66.076L84.0634 66.0773L83.2701 66.417C83.1129 66.4844 82.9318 66.4114 82.8644 66.2542C82.7984 66.0984 82.87 65.9173 83.0245 65.85Z",
    fill: "url(#paint37_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.685 64.7199L86.4881 64.4055C86.6566 64.3395 86.8461 64.4223 86.9121 64.5908C86.9781 64.7592 86.8953 64.9487 86.7268 65.0146L86.724 65.016L85.9181 65.3234C85.751 65.3866 85.5643 65.3038 85.5011 65.1367C85.4393 64.9697 85.5208 64.7845 85.685 64.7199Z",
    fill: "url(#paint38_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3934 63.7054L89.2091 63.4247C89.3846 63.3643 89.5769 63.457 89.6373 63.6338C89.6977 63.8092 89.605 64.0015 89.4281 64.0619H89.4267L88.6096 64.3384C88.4341 64.3973 88.2446 64.3033 88.1856 64.1293C88.1266 63.9538 88.2207 63.7643 88.3934 63.7054Z",
    fill: "url(#paint39_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1336 62.7958L91.9591 62.546C92.1417 62.4912 92.334 62.5937 92.3888 62.7762C92.4435 62.9586 92.341 63.1509 92.1585 63.2056H92.1571L91.3302 63.4499C91.149 63.5032 90.9581 63.4007 90.9047 63.2197C90.8514 63.04 90.9539 62.8491 91.1336 62.7958Z",
    fill: "url(#paint40_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9125 62.0025L94.7465 61.785C94.9346 61.7358 95.1269 61.8481 95.1761 62.0362C95.2252 62.2243 95.1129 62.4166 94.9248 62.4657H94.9234L94.0894 62.679C93.9027 62.7268 93.7117 62.6131 93.664 62.4264C93.6148 62.2411 93.7258 62.0516 93.9125 62.0025Z",
    fill: "url(#paint41_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7143 61.3126L97.5567 61.1259C97.7504 61.0824 97.9428 61.2059 97.9863 61.3996C98.0298 61.5933 97.9063 61.7856 97.7125 61.8291H97.7111L96.8673 62.0116C96.6736 62.0537 96.484 61.9302 96.4419 61.7379C96.3998 61.5456 96.5219 61.3561 96.7143 61.3126Z",
    fill: "url(#paint42_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5374 60.7244L100.385 60.5686C100.585 60.5321 100.777 60.664 100.814 60.8633C100.85 61.0626 100.718 61.2549 100.519 61.2914H100.517L99.668 61.443C99.4686 61.4781 99.2791 61.3461 99.244 61.1468C99.2089 60.9503 99.3394 60.7608 99.5374 60.7244Z",
    fill: "url(#paint43_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.389 60.2382L103.242 60.1133C103.447 60.0838 103.638 60.2255 103.668 60.4304C103.697 60.6354 103.555 60.8263 103.35 60.8557H103.349L102.495 60.9764C102.292 61.0045 102.102 60.8627 102.074 60.6592C102.045 60.4557 102.187 60.2676 102.389 60.2382Z",
    fill: "url(#paint44_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.249 59.8543L106.107 59.7603C106.318 59.7364 106.507 59.8894 106.53 60.0999C106.552 60.3105 106.4 60.4999 106.19 60.5224H106.188L105.331 60.6122C105.121 60.6347 104.935 60.4817 104.912 60.2726C104.891 60.0634 105.041 59.8782 105.249 59.8543Z",
    fill: "url(#paint45_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.125 59.5798L108.985 59.5166C109.2 59.5012 109.388 59.6626 109.404 59.8774C109.419 60.0921 109.258 60.2802 109.043 60.2956H109.041L108.181 60.3546C107.966 60.3686 107.781 60.2072 107.767 59.9938C107.751 59.7791 107.913 59.5952 108.125 59.5798Z",
    fill: "url(#paint46_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.01 59.3998L111.872 59.3675C112.092 59.3591 112.277 59.5303 112.286 59.7507C112.294 59.971 112.123 60.1563 111.903 60.1647H111.9L111.038 60.1928C110.819 60.1998 110.636 60.0286 110.629 59.8096C110.622 59.5907 110.792 59.4082 111.01 59.3998Z",
    fill: "url(#paint47_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.897 59.3295L114.759 59.3281C114.983 59.3281 115.166 59.5092 115.166 59.7338C115.166 59.9583 114.985 60.1408 114.76 60.1408H114.757L113.895 60.138C113.672 60.1366 113.491 59.9555 113.492 59.7323C113.495 59.5092 113.675 59.3295 113.897 59.3295Z",
    fill: "url(#paint48_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.79 59.3597L117.652 59.3891C117.881 59.3962 118.06 59.5884 118.053 59.8172C118.046 60.046 117.853 60.2257 117.624 60.2172H117.622L116.759 60.1835C116.532 60.1751 116.355 59.9828 116.364 59.7555C116.373 59.5281 116.563 59.3512 116.79 59.3597Z",
    fill: "url(#paint49_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.673 59.4855L120.534 59.5459C120.767 59.5613 120.942 59.7634 120.925 59.9964C120.909 60.2294 120.708 60.4048 120.475 60.388H120.472L119.611 60.3234C119.38 60.3066 119.207 60.1045 119.224 59.8729C119.242 59.6427 119.443 59.4687 119.673 59.4855Z",
    fill: "url(#paint50_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.556 59.7291L123.414 59.8203C123.65 59.8456 123.821 60.0575 123.796 60.2933C123.771 60.5291 123.559 60.7003 123.323 60.6751H123.32L122.462 60.5796C122.228 60.553 122.059 60.3424 122.085 60.108C122.111 59.8722 122.322 59.7038 122.556 59.7291Z",
    fill: "url(#paint51_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.423 60.0669L126.277 60.1862C126.516 60.2199 126.683 60.4416 126.649 60.6802C126.615 60.9188 126.393 61.0859 126.155 61.0522H126.152L125.298 60.9273C125.061 60.8922 124.895 60.6718 124.93 60.4346C124.967 60.1974 125.186 60.0332 125.423 60.0669Z",
    fill: "url(#paint52_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.281 60.5063L129.13 60.6523C129.373 60.6944 129.536 60.9246 129.494 61.166C129.452 61.4088 129.222 61.5716 128.98 61.5295H128.977L128.128 61.3793C127.886 61.3372 127.726 61.107 127.768 60.8656C127.812 60.6256 128.041 60.4656 128.281 60.5063Z",
    fill: "url(#paint53_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.122 61.0247L131.967 61.1959C132.213 61.245 132.372 61.485 132.321 61.7293C132.272 61.9749 132.032 62.1335 131.788 62.0829H131.785L130.941 61.9075C130.697 61.857 130.541 61.6184 130.592 61.3742C130.642 61.1313 130.879 60.9755 131.122 61.0247Z",
    fill: "url(#paint54_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.947 61.6294L134.787 61.8245C135.034 61.882 135.188 62.129 135.131 62.3775C135.073 62.6245 134.825 62.7789 134.578 62.7213H134.575L133.735 62.522C133.49 62.4631 133.336 62.2161 133.395 61.9704C133.454 61.7234 133.702 61.5718 133.947 61.6294Z",
    fill: "url(#paint55_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.752 62.3127L137.586 62.5331C137.833 62.599 137.981 62.8517 137.916 63.0987C137.85 63.3457 137.597 63.4931 137.35 63.4285H137.349L136.515 63.2068C136.268 63.1408 136.122 62.8882 136.188 62.6411C136.254 62.3927 136.506 62.2467 136.752 62.3127Z",
    fill: "url(#paint56_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.535 63.074L140.362 63.3168C140.609 63.3898 140.75 63.648 140.678 63.8951C140.605 64.1421 140.347 64.2824 140.1 64.2109H140.098L139.271 63.9666C139.025 63.8937 138.884 63.6354 138.957 63.3884C139.031 63.1414 139.289 63.001 139.535 63.074Z",
    fill: "url(#paint57_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.299 63.9137L143.12 64.179C143.366 64.259 143.502 64.5228 143.422 64.7685C143.342 65.0141 143.078 65.1502 142.832 65.0702H142.831L142.011 64.8036C141.765 64.7236 141.631 64.4597 141.711 64.2141C141.791 63.9684 142.053 63.8337 142.299 63.9137Z",
    fill: "url(#paint58_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.037 64.824L145.851 65.109C146.097 65.1946 146.226 65.464 146.139 65.7097C146.053 65.9553 145.784 66.0844 145.538 65.9974H145.537L144.724 65.7111C144.479 65.6255 144.35 65.356 144.437 65.1118C144.524 64.8661 144.791 64.737 145.037 64.824Z",
    fill: "url(#paint59_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.751 65.8121L148.557 66.1166C148.801 66.2093 148.925 66.4829 148.832 66.7272C148.739 66.9714 148.466 67.0949 148.221 67.0023H148.22L147.414 66.6949C147.17 66.6023 147.048 66.3286 147.14 66.0857C147.234 65.8429 147.507 65.7194 147.751 65.8121Z",
    fill: "url(#paint60_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.441 66.8479L151.239 67.1721C151.484 67.2704 151.6 67.5483 151.502 67.7925C151.404 68.0353 151.126 68.1532 150.881 68.055H150.88L150.081 67.7293C149.838 67.6297 149.722 67.3532 149.82 67.1104C149.921 66.8662 150.198 66.7483 150.441 66.8479Z",
    fill: "url(#paint61_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.104 67.9538L153.896 68.2963C154.139 68.4016 154.25 68.6823 154.146 68.9251C154.04 69.1679 153.76 69.2788 153.517 69.1749H153.515L152.725 68.831C152.483 68.7258 152.373 68.4451 152.476 68.2022C152.582 67.9594 152.863 67.8486 153.104 67.9538Z",
    fill: "url(#paint62_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.748 69.1222L156.531 69.4816C156.773 69.5924 156.88 69.8773 156.769 70.1188C156.658 70.3602 156.373 70.4668 156.131 70.356H156.13L155.346 69.9952C155.105 69.8844 155 69.5994 155.111 69.358C155.221 69.1166 155.506 69.0114 155.748 69.1222Z",
    fill: "url(#paint63_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.363 70.3375L159.139 70.7123C159.379 70.8288 159.48 71.1179 159.364 71.3579C159.247 71.5979 158.958 71.699 158.718 71.5825H158.716L157.94 71.2063C157.7 71.0898 157.6 70.8007 157.717 70.5607C157.835 70.3221 158.122 70.221 158.363 70.3375Z",
    fill: "url(#paint64_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.948 71.6078L161.718 71.998C161.958 72.1201 162.053 72.4121 161.931 72.6521C161.809 72.8921 161.517 72.9875 161.277 72.8654H161.275L160.507 72.4738C160.269 72.3517 160.173 72.0598 160.295 71.8212C160.418 71.5812 160.71 71.4857 160.948 71.6078Z",
    fill: "url(#paint65_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.508 72.94L164.269 73.3457C164.507 73.472 164.597 73.7681 164.471 74.0067C164.344 74.2453 164.048 74.3352 163.809 74.2088H163.808L163.047 73.8018C162.81 73.6755 162.72 73.3793 162.846 73.1407C162.975 72.9035 163.27 72.8137 163.508 72.94Z",
    fill: "url(#paint66_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.047 74.3117L166.8 74.73C167.037 74.8619 167.123 75.1609 166.991 75.3981C166.859 75.6353 166.56 75.7209 166.322 75.5889H166.321L165.568 75.1693C165.331 75.0373 165.247 74.7384 165.379 74.5026C165.511 74.2668 165.81 74.1798 166.047 74.3117Z",
    fill: "url(#paint67_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.556 75.7232L169.303 76.1541C169.539 76.2902 169.62 76.592 169.484 76.8292C169.348 77.065 169.045 77.1464 168.809 77.0089H168.808L168.062 76.5766C167.826 76.4404 167.746 76.1387 167.884 75.9029C168.02 75.6671 168.32 75.5857 168.556 75.7232Z",
    fill: "url(#paint68_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.048 77.1808L171.788 77.6244C172.022 77.7647 172.099 78.0707 171.958 78.3051C171.816 78.5395 171.511 78.6167 171.277 78.4749H171.275L170.537 78.03C170.302 77.8882 170.227 77.5837 170.368 77.3493C170.51 77.1149 170.813 77.0391 171.048 77.1808Z",
    fill: "url(#paint69_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.51 78.6772L174.243 79.1334C174.477 79.2794 174.549 79.5867 174.403 79.8211C174.257 80.0555 173.949 80.1271 173.715 79.9811H173.713L172.98 79.5236C172.747 79.3776 172.676 79.0702 172.822 78.8372C172.971 78.6028 173.277 78.5313 173.51 78.6772Z",
    fill: "url(#paint70_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.951 80.2128L176.677 80.6788C176.91 80.8289 176.978 81.1391 176.829 81.3721C176.679 81.6051 176.368 81.6725 176.135 81.5237H176.134L175.409 81.0563C175.176 80.9061 175.11 80.5959 175.259 80.3644C175.409 80.13 175.718 80.0626 175.951 80.2128Z",
    fill: "url(#paint71_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.37 81.7788L179.089 82.2546C179.32 82.409 179.385 82.7206 179.23 82.9535C179.076 83.1851 178.764 83.2497 178.531 83.0953H178.53L177.811 82.6181C177.579 82.4637 177.516 82.1521 177.67 81.9205C177.826 81.6889 178.138 81.6258 178.37 81.7788Z",
    fill: "url(#paint72_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.76 83.3855L181.473 83.8711C181.705 84.0283 181.764 84.3441 181.607 84.5757C181.45 84.8072 181.134 84.8662 180.902 84.709H180.901L180.189 84.222C179.959 84.0648 179.9 83.749 180.057 83.5188C180.214 83.2872 180.529 83.2268 180.76 83.3855Z",
    fill: "url(#paint73_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.134 85.0141L183.84 85.5082C184.07 85.6696 184.126 85.9868 183.965 86.217C183.803 86.4472 183.486 86.5033 183.256 86.3419H183.254L182.548 85.8464C182.318 85.685 182.263 85.3678 182.425 85.1376C182.588 84.9089 182.905 84.8527 183.134 85.0141Z",
    fill: "url(#paint74_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.493 86.6818L186.193 87.1842C186.424 87.3485 186.475 87.6685 186.311 87.8987C186.147 88.1288 185.827 88.1808 185.597 88.0152H185.595L184.896 87.5113C184.667 87.3457 184.615 87.0271 184.779 86.7983C184.945 86.5695 185.264 86.5176 185.493 86.6818Z",
    fill: "url(#paint75_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.822 88.358L188.517 88.8689C188.746 89.0373 188.795 89.3587 188.626 89.5875C188.458 89.8163 188.136 89.8654 187.908 89.697H187.906L187.213 89.1847C186.984 89.0163 186.936 88.6949 187.105 88.4661C187.273 88.2387 187.595 88.1896 187.822 88.358Z",
    fill: "url(#paint76_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.14 90.081L190.83 90.5989C191.059 90.7701 191.104 91.0944 190.933 91.3231C190.761 91.5519 190.437 91.5968 190.208 91.4256H190.207L189.518 90.9063C189.29 90.7351 189.245 90.4108 189.416 90.1835C189.589 89.9547 189.912 89.9084 190.14 90.081Z",
    fill: "url(#paint77_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.436 91.818L193.121 92.3444C193.348 92.5184 193.39 92.844 193.216 93.0714C193.042 93.2988 192.716 93.3409 192.489 93.1669L191.805 92.6419C191.578 92.4679 191.534 92.1423 191.708 91.9149C191.882 91.6861 192.208 91.644 192.436 91.818Z",
    fill: "url(#paint78_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.71 93.5789L195.389 94.1109C195.614 94.2863 195.653 94.6106 195.478 94.8351C195.302 95.0597 194.978 95.099 194.754 94.9235L194.074 94.393C193.849 94.2176 193.809 93.8933 193.984 93.6674C194.16 93.4428 194.484 93.4021 194.71 93.5789Z",
    fill: "url(#paint79_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.975 95.3615L197.65 95.8976C197.872 96.0745 197.908 96.3973 197.733 96.6191C197.556 96.8408 197.234 96.8787 197.012 96.7019L196.336 96.1657C196.112 95.9903 196.076 95.6661 196.251 95.4443C196.428 95.2225 196.751 95.1846 196.975 95.3615Z",
    fill: "url(#paint80_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.224 97.1529L199.895 97.6947C200.114 97.8715 200.149 98.1929 199.972 98.4119C199.795 98.6308 199.475 98.6659 199.254 98.4891L198.582 97.9487C198.362 97.7719 198.326 97.4504 198.503 97.2301C198.682 97.0097 199.003 96.9746 199.224 97.1529Z",
    fill: "url(#paint81_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.462 98.9662L202.131 99.5108C202.348 99.6876 202.381 100.008 202.204 100.225C202.027 100.443 201.708 100.475 201.49 100.298L200.821 99.7536C200.603 99.5767 200.569 99.2567 200.746 99.0392C200.923 98.8216 201.243 98.7879 201.462 98.9662Z",
    fill: "url(#paint82_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69 100.796L204.357 101.344C204.572 101.521 204.602 101.84 204.426 102.055C204.249 102.269 203.931 102.302 203.715 102.123L203.048 101.576C202.832 101.399 202.801 101.08 202.978 100.864C203.155 100.648 203.474 100.617 203.69 100.796Z",
    fill: "url(#paint83_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.906 102.623L206.57 103.175C206.784 103.352 206.813 103.669 206.636 103.882C206.459 104.096 206.143 104.125 205.93 103.948L205.264 103.398C205.051 103.221 205.02 102.904 205.197 102.691C205.375 102.476 205.691 102.446 205.906 102.623Z",
    fill: "url(#paint84_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.117 104.46L208.78 105.013C208.992 105.189 209.02 105.504 208.843 105.716C208.666 105.928 208.352 105.956 208.141 105.779L207.477 105.227C207.265 105.05 207.236 104.736 207.413 104.523C207.588 104.312 207.904 104.283 208.117 104.46Z",
    fill: "url(#paint85_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.326 106.312L210.987 106.867C211.198 107.044 211.225 107.357 211.048 107.566C210.871 107.777 210.559 107.804 210.349 107.628L209.686 107.074C209.475 106.898 209.447 106.584 209.624 106.373C209.801 106.163 210.114 106.135 210.326 106.312Z",
    fill: "url(#paint86_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.525 108.163L213.185 108.719C213.394 108.895 213.42 109.206 213.243 109.414C213.068 109.623 212.758 109.65 212.549 109.474L211.887 108.92C211.678 108.744 211.651 108.433 211.827 108.224C212.002 108.015 212.315 107.986 212.525 108.163Z",
    fill: "url(#paint87_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.726 110.014L215.386 110.572C215.594 110.746 215.619 111.056 215.445 111.264C215.27 111.471 214.961 111.498 214.754 111.323L214.093 110.767C213.885 110.593 213.859 110.283 214.033 110.073C214.207 109.866 214.517 109.839 214.726 110.014Z",
    fill: "url(#paint88_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.928 111.865L217.588 112.422C217.794 112.596 217.82 112.904 217.647 113.11C217.473 113.316 217.165 113.343 216.96 113.169L216.299 112.613C216.093 112.439 216.066 112.132 216.239 111.924C216.413 111.718 216.722 111.691 216.928 111.865Z",
    fill: "url(#paint89_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.123 113.715L219.784 114.271C219.989 114.444 220.016 114.75 219.843 114.955C219.671 115.16 219.366 115.186 219.16 115.014L218.498 114.459C218.292 114.287 218.265 113.981 218.438 113.774C218.609 113.57 218.917 113.543 219.123 113.715Z",
    fill: "url(#paint90_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.326 115.565L221.987 116.12C222.191 116.291 222.219 116.596 222.047 116.799C221.876 117.003 221.573 117.031 221.368 116.859L220.705 116.306C220.5 116.135 220.472 115.831 220.643 115.626C220.815 115.422 221.119 115.394 221.326 115.565Z",
    fill: "url(#paint91_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.53 117.416L224.193 117.969C224.397 118.139 224.425 118.44 224.255 118.644C224.085 118.847 223.783 118.876 223.579 118.706L222.915 118.154C222.712 117.984 222.684 117.681 222.852 117.478C223.022 117.274 223.325 117.246 223.53 117.416Z",
    fill: "url(#paint92_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.74 119.25L226.406 119.8C226.609 119.969 226.638 120.269 226.469 120.471C226.301 120.675 226.002 120.703 225.798 120.536L225.131 119.987C224.927 119.818 224.898 119.518 225.066 119.315C225.235 119.111 225.537 119.082 225.74 119.25Z",
    fill: "url(#paint93_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.957 121.076L228.623 121.623C228.826 121.789 228.855 122.088 228.689 122.29C228.524 122.492 228.225 122.523 228.023 122.356L227.354 121.81C227.151 121.644 227.121 121.345 227.287 121.142C227.454 120.94 227.753 120.91 227.957 121.076Z",
    fill: "url(#paint94_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.185 122.895L230.854 123.438C231.056 123.602 231.087 123.899 230.923 124.101C230.759 124.303 230.463 124.334 230.26 124.171L229.589 123.629C229.387 123.465 229.355 123.169 229.519 122.965C229.685 122.762 229.981 122.729 230.185 122.895Z",
    fill: "url(#paint95_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.422 124.697L233.096 125.236C233.298 125.397 233.331 125.692 233.169 125.894C233.008 126.096 232.713 126.129 232.511 125.967L231.837 125.43C231.635 125.268 231.601 124.974 231.762 124.77C231.922 124.568 232.219 124.534 232.422 124.697Z",
    fill: "url(#paint96_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.669 126.491L235.346 127.026C235.548 127.186 235.582 127.478 235.423 127.68C235.264 127.882 234.971 127.917 234.77 127.757L234.092 127.224C233.89 127.065 233.855 126.772 234.013 126.568C234.173 126.366 234.467 126.331 234.669 126.491Z",
    fill: "url(#paint97_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.924 128.269L237.605 128.799C237.807 128.956 237.844 129.246 237.687 129.448C237.529 129.651 237.24 129.687 237.038 129.53L236.356 129.002C236.154 128.845 236.116 128.554 236.273 128.352C236.43 128.149 236.721 128.112 236.924 128.269Z",
    fill: "url(#paint98_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.193 130.017L239.878 130.541C240.079 130.695 240.118 130.983 239.964 131.183C239.809 131.384 239.523 131.425 239.322 131.27L238.635 130.75C238.433 130.595 238.393 130.306 238.547 130.104C238.701 129.902 238.991 129.861 239.193 130.016V130.017Z",
    fill: "url(#paint99_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.479 131.764L242.168 132.282C242.368 132.43 242.407 132.714 242.258 132.912C242.109 133.11 241.829 133.15 241.629 133.003L240.937 132.489C240.736 132.341 240.694 132.057 240.843 131.855C240.992 131.654 241.275 131.612 241.478 131.761L241.479 131.764Z",
    fill: "url(#paint100_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.779 133.477L244.474 133.988C244.671 134.132 244.713 134.409 244.568 134.605C244.423 134.802 244.148 134.844 243.952 134.701L243.254 134.194C243.055 134.05 243.011 133.772 243.156 133.574C243.3 133.376 243.578 133.331 243.776 133.475L243.779 133.477Z",
    fill: "url(#paint101_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.093 135.16L246.794 135.662C246.989 135.802 247.033 136.073 246.894 136.267C246.755 136.461 246.485 136.506 246.29 136.368L245.586 135.87C245.39 135.731 245.343 135.459 245.482 135.262C245.621 135.066 245.894 135.019 246.09 135.158L246.093 135.16Z",
    fill: "url(#paint102_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.435 136.828L249.141 137.322C249.333 137.456 249.379 137.722 249.245 137.914C249.11 138.106 248.847 138.152 248.655 138.019L247.946 137.529C247.752 137.395 247.703 137.129 247.838 136.934C247.973 136.74 248.238 136.691 248.433 136.826L248.435 136.828Z",
    fill: "url(#paint103_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.792 138.457L251.506 138.943C251.696 139.072 251.746 139.332 251.615 139.521C251.486 139.71 251.228 139.76 251.038 139.632L250.322 139.15C250.13 139.021 250.079 138.76 250.208 138.568C250.337 138.376 250.599 138.325 250.791 138.454L250.792 138.457Z",
    fill: "url(#paint104_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.171 140.068L253.892 140.542C254.08 140.665 254.132 140.919 254.008 141.108C253.885 141.296 253.633 141.348 253.445 141.225L252.722 140.755C252.533 140.632 252.478 140.378 252.601 140.187C252.725 139.997 252.979 139.943 253.17 140.066L253.171 140.068Z",
    fill: "url(#paint105_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.573 141.625L256.303 142.084C256.49 142.202 256.546 142.448 256.429 142.636C256.313 142.822 256.067 142.878 255.88 142.762L255.147 142.307C254.958 142.191 254.9 141.942 255.018 141.753C255.135 141.563 255.383 141.506 255.573 141.624V141.625Z",
    fill: "url(#paint106_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.016 143.133L258.759 143.573C258.946 143.682 259.006 143.922 258.896 144.109C258.787 144.294 258.548 144.356 258.363 144.248L257.617 143.813C257.429 143.703 257.366 143.462 257.476 143.274C257.585 143.086 257.827 143.022 258.015 143.132L258.016 143.133Z",
    fill: "url(#paint107_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.492 144.555L261.249 144.97C261.434 145.071 261.503 145.304 261.4 145.489C261.299 145.674 261.067 145.741 260.882 145.642L260.124 145.232C259.937 145.131 259.867 144.897 259.968 144.71C260.069 144.523 260.304 144.453 260.49 144.554L260.492 144.555Z",
    fill: "url(#paint108_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.016 145.899L263.789 146.284C263.974 146.376 264.048 146.601 263.957 146.786C263.866 146.97 263.641 147.046 263.457 146.955L262.684 146.574C262.497 146.483 262.42 146.257 262.511 146.07C262.602 145.884 262.828 145.806 263.015 145.898L263.016 145.899Z",
    fill: "url(#paint109_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.592 147.132L266.381 147.482C266.567 147.563 266.649 147.779 266.568 147.965C266.487 148.149 266.272 148.233 266.086 148.151L265.296 147.807C265.109 147.726 265.024 147.509 265.105 147.323C265.186 147.137 265.404 147.051 265.589 147.132H265.592Z",
    fill: "url(#paint110_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.23 148.241L269.036 148.548C269.22 148.618 269.313 148.824 269.242 149.01C269.172 149.194 268.967 149.286 268.783 149.217L267.976 148.916C267.789 148.846 267.695 148.639 267.765 148.453C267.836 148.266 268.042 148.172 268.229 148.242L268.23 148.241Z",
    fill: "url(#paint111_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.918 149.195L271.742 149.454C271.926 149.511 272.028 149.706 271.971 149.892C271.913 150.075 271.718 150.177 271.535 150.12L270.71 149.868C270.524 149.81 270.419 149.614 270.477 149.428C270.534 149.243 270.731 149.138 270.916 149.195H270.918Z",
    fill: "url(#paint112_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.653 149.987L274.492 150.187C274.674 150.231 274.788 150.415 274.744 150.597C274.701 150.78 274.518 150.892 274.336 150.85L273.496 150.655C273.312 150.611 273.197 150.427 273.239 150.242C273.283 150.058 273.467 149.943 273.652 149.985L273.653 149.987Z",
    fill: "url(#paint113_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.446 150.583L277.298 150.72C277.479 150.749 277.603 150.919 277.573 151.1C277.544 151.281 277.375 151.403 277.194 151.375L276.342 151.243C276.159 151.215 276.034 151.044 276.063 150.861C276.091 150.679 276.262 150.554 276.444 150.582L276.446 150.583Z",
    fill: "url(#paint114_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.266 150.955L280.125 151.023C280.3 151.037 280.431 151.19 280.417 151.364C280.403 151.538 280.253 151.667 280.078 151.656L279.218 151.597C279.041 151.584 278.906 151.431 278.919 151.253C278.931 151.076 279.084 150.941 279.263 150.954L279.266 150.955Z",
    fill: "url(#paint115_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.108 151.092L282.97 151.078C283.137 151.075 283.275 151.209 283.278 151.376C283.28 151.541 283.148 151.679 282.983 151.683L282.121 151.707C281.951 151.711 281.81 151.578 281.805 151.408C281.801 151.238 281.934 151.098 282.104 151.092H282.108Z",
    fill: "url(#paint116_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.944 150.94L285.799 150.83C285.957 150.811 286.101 150.922 286.121 151.079C286.141 151.235 286.031 151.378 285.875 151.4L285.02 151.518C284.86 151.541 284.713 151.428 284.69 151.27C284.668 151.11 284.78 150.962 284.939 150.94H284.944Z",
    fill: "url(#paint117_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.751 150.472L288.59 150.273C288.736 150.238 288.884 150.329 288.919 150.475C288.954 150.621 288.864 150.767 288.72 150.802L287.883 151.01C287.734 151.046 287.584 150.957 287.547 150.808C287.511 150.659 287.601 150.509 287.749 150.472H287.751Z",
    fill: "url(#paint118_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.496 149.713L291.31 149.428C291.445 149.382 291.591 149.452 291.639 149.586C291.685 149.719 291.616 149.865 291.483 149.913L290.672 150.206C290.535 150.255 290.385 150.185 290.336 150.049C290.287 149.913 290.357 149.762 290.493 149.713H290.496Z",
    fill: "url(#paint119_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.144 148.682L293.923 148.313C294.044 148.255 294.189 148.307 294.246 148.428C294.304 148.548 294.253 148.692 294.134 148.749L293.359 149.127C293.237 149.186 293.088 149.135 293.029 149.013C292.969 148.891 293.021 148.742 293.143 148.683L293.144 148.682Z",
    fill: "url(#paint120_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.669 147.355L296.402 146.901C296.509 146.835 296.649 146.868 296.715 146.974C296.781 147.081 296.749 147.22 296.644 147.286L295.915 147.748C295.807 147.816 295.664 147.784 295.595 147.676C295.526 147.568 295.558 147.425 295.666 147.356L295.669 147.355Z",
    fill: "url(#paint121_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.032 145.763L298.706 145.226C298.797 145.153 298.93 145.168 299.003 145.259C299.076 145.351 299.061 145.483 298.971 145.556L298.303 146.1C298.21 146.176 298.074 146.162 297.998 146.069C297.922 145.977 297.936 145.841 298.029 145.765L298.032 145.763Z",
    fill: "url(#paint122_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.176 143.892L300.775 143.271C300.851 143.193 300.976 143.191 301.055 143.266C301.132 143.34 301.135 143.465 301.062 143.543L300.469 144.171C300.394 144.252 300.266 144.255 300.184 144.179C300.103 144.103 300.1 143.976 300.176 143.894V143.892Z",
    fill: "url(#paint123_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.044 141.745L302.548 141.044C302.607 140.963 302.72 140.945 302.802 141.002C302.883 141.061 302.902 141.173 302.844 141.255L302.347 141.959C302.288 142.044 302.172 142.063 302.087 142.004C302.003 141.945 301.982 141.829 302.042 141.745H302.044Z",
    fill: "url(#paint124_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.582 139.347L303.969 138.576C304.011 138.494 304.111 138.461 304.194 138.502C304.275 138.543 304.309 138.642 304.268 138.725L303.889 139.5C303.847 139.585 303.745 139.621 303.659 139.578C303.573 139.536 303.538 139.434 303.58 139.348L303.582 139.347Z",
    fill: "url(#paint125_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.714 136.744L304.968 135.92C304.993 135.84 305.077 135.795 305.157 135.819C305.238 135.843 305.282 135.927 305.259 136.007L305.014 136.834C304.99 136.916 304.902 136.964 304.819 136.939C304.736 136.914 304.689 136.828 304.714 136.744Z",
    fill: "url(#paint126_linear_4296_17492)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.276 187.167C248.117 187.167 247.988 187.037 247.988 186.879C247.988 186.72 248.117 186.591 248.276 186.591C248.562 186.591 248.847 186.588 249.134 186.584C249.135 186.584 249.136 186.584 249.139 186.584C249.295 186.584 249.424 186.709 249.427 186.866C249.43 187.025 249.304 187.155 249.145 187.158C248.854 187.165 248.565 187.167 248.276 187.167ZM246.264 187.126C246.26 187.126 246.255 187.126 246.253 187.126C245.963 187.115 245.674 187.101 245.385 187.084C245.226 187.075 245.106 186.939 245.114 186.781C245.124 186.622 245.263 186.504 245.417 186.51C245.704 186.527 245.989 186.541 246.275 186.552C246.434 186.559 246.557 186.692 246.55 186.851C246.545 187.005 246.417 187.126 246.264 187.126ZM251.15 187.081C251 187.081 250.872 186.963 250.863 186.811C250.854 186.653 250.974 186.517 251.133 186.507C251.418 186.49 251.704 186.47 251.988 186.448C252.145 186.431 252.284 186.553 252.297 186.712C252.309 186.87 252.192 187.008 252.033 187.021C251.745 187.043 251.456 187.063 251.167 187.081C251.161 187.081 251.155 187.081 251.15 187.081ZM243.396 186.929C243.386 186.929 243.377 186.929 243.367 186.928C243.08 186.9 242.792 186.87 242.504 186.838C242.347 186.82 242.233 186.678 242.251 186.52C242.27 186.361 242.413 186.251 242.569 186.265C242.854 186.298 243.137 186.327 243.422 186.355C243.581 186.371 243.696 186.511 243.681 186.668C243.667 186.818 243.542 186.929 243.396 186.929ZM254.012 186.818C253.869 186.818 253.746 186.712 253.727 186.566C253.708 186.409 253.82 186.264 253.977 186.246C254.261 186.211 254.545 186.173 254.827 186.132C254.984 186.111 255.13 186.219 255.153 186.376C255.175 186.534 255.065 186.68 254.908 186.702C254.622 186.743 254.335 186.781 254.048 186.817C254.036 186.818 254.024 186.818 254.012 186.818ZM240.541 186.577C240.527 186.577 240.513 186.576 240.498 186.574C240.211 186.531 239.926 186.486 239.64 186.438C239.483 186.411 239.377 186.264 239.404 186.107C239.431 185.951 239.578 185.844 239.735 185.871C240.018 185.919 240.3 185.964 240.583 186.006C240.741 186.03 240.849 186.176 240.825 186.333C240.804 186.475 240.682 186.577 240.541 186.577ZM256.853 186.372C256.718 186.372 256.597 186.277 256.571 186.139C256.541 185.983 256.642 185.833 256.798 185.802C257.079 185.749 257.358 185.691 257.638 185.632C257.793 185.6 257.945 185.698 257.979 185.854C258.011 186.01 257.913 186.162 257.757 186.195C257.473 186.256 257.19 186.312 256.906 186.367C256.888 186.371 256.87 186.372 256.853 186.372ZM237.711 186.075C237.691 186.075 237.673 186.073 237.653 186.069C237.37 186.011 237.087 185.951 236.804 185.889C236.649 185.856 236.551 185.703 236.585 185.547C236.618 185.392 236.772 185.294 236.927 185.328C237.207 185.39 237.488 185.449 237.767 185.505C237.923 185.537 238.022 185.689 237.992 185.844C237.964 185.981 237.844 186.075 237.711 186.075ZM259.655 185.735C259.527 185.735 259.411 185.649 259.377 185.52C259.336 185.367 259.428 185.21 259.582 185.169C259.859 185.096 260.134 185.021 260.408 184.942C260.561 184.9 260.719 184.987 260.763 185.14C260.806 185.293 260.718 185.451 260.565 185.495C260.287 185.575 260.008 185.651 259.728 185.725C259.704 185.732 259.679 185.735 259.655 185.735ZM234.907 185.432C234.883 185.432 234.859 185.429 234.835 185.423C234.556 185.352 234.275 185.277 233.997 185.202C233.844 185.159 233.754 185.002 233.795 184.849C233.837 184.696 233.996 184.606 234.147 184.647C234.424 184.723 234.701 184.795 234.979 184.866C235.133 184.905 235.226 185.063 235.186 185.216C235.153 185.345 235.036 185.432 234.907 185.432ZM262.407 184.904C262.288 184.904 262.175 184.83 262.135 184.709C262.083 184.559 262.163 184.396 262.313 184.344C262.582 184.251 262.852 184.156 263.12 184.058C263.269 184.004 263.435 184.08 263.489 184.229C263.544 184.378 263.467 184.543 263.318 184.598C263.046 184.698 262.773 184.795 262.5 184.887C262.469 184.9 262.438 184.904 262.407 184.904ZM232.14 184.651C232.112 184.651 232.084 184.647 232.056 184.639C231.779 184.553 231.504 184.468 231.229 184.378C231.077 184.329 230.994 184.167 231.043 184.016C231.092 183.864 231.254 183.783 231.405 183.83C231.678 183.919 231.952 184.004 232.224 184.089C232.376 184.135 232.461 184.296 232.414 184.448C232.376 184.573 232.262 184.651 232.14 184.651ZM265.09 183.877C264.978 183.877 264.872 183.811 264.826 183.703C264.764 183.557 264.832 183.388 264.978 183.325C265.24 183.213 265.501 183.099 265.761 182.981C265.906 182.915 266.076 182.98 266.142 183.124C266.208 183.269 266.143 183.439 265.998 183.505C265.734 183.624 265.469 183.741 265.204 183.854C265.166 183.87 265.128 183.877 265.09 183.877ZM229.412 183.741C229.38 183.741 229.347 183.735 229.315 183.724C229.043 183.625 228.772 183.526 228.502 183.425C228.353 183.369 228.279 183.203 228.335 183.054C228.391 182.905 228.557 182.831 228.706 182.887C228.974 182.988 229.242 183.086 229.512 183.183C229.66 183.237 229.739 183.402 229.684 183.551C229.641 183.668 229.53 183.741 229.412 183.741ZM226.732 182.705C226.695 182.705 226.657 182.698 226.622 182.682C226.355 182.571 226.089 182.459 225.825 182.345C225.679 182.282 225.611 182.114 225.674 181.968C225.738 181.822 225.906 181.754 226.052 181.818C226.315 181.93 226.579 182.042 226.844 182.152C226.99 182.212 227.06 182.38 227 182.528C226.951 182.637 226.844 182.705 226.732 182.705ZM267.689 182.653C267.585 182.653 267.484 182.597 267.433 182.497C267.36 182.357 267.415 182.183 267.557 182.11C267.809 181.979 268.061 181.844 268.312 181.708C268.451 181.631 268.627 181.683 268.702 181.822C268.778 181.961 268.728 182.136 268.589 182.212C268.335 182.351 268.079 182.487 267.822 182.62C267.779 182.643 267.734 182.653 267.689 182.653ZM224.101 181.545C224.06 181.545 224.018 181.537 223.978 181.519C223.717 181.397 223.456 181.272 223.196 181.145C223.053 181.077 222.994 180.904 223.063 180.761C223.132 180.618 223.304 180.559 223.448 180.627C223.705 180.752 223.963 180.876 224.223 180.997C224.366 181.064 224.428 181.235 224.36 181.378C224.311 181.485 224.209 181.545 224.101 181.545ZM221.526 180.267C221.481 180.267 221.434 180.255 221.392 180.234C221.137 180.1 220.883 179.964 220.628 179.826C220.489 179.75 220.438 179.576 220.513 179.436C220.589 179.297 220.763 179.245 220.904 179.321C221.155 179.457 221.408 179.592 221.66 179.725C221.801 179.799 221.856 179.972 221.781 180.114C221.729 180.212 221.628 180.267 221.526 180.267ZM219.012 178.873C218.963 178.873 218.913 178.86 218.868 178.834C218.618 178.688 218.371 178.54 218.124 178.392C217.988 178.31 217.944 178.133 218.027 177.997C218.108 177.861 218.285 177.818 218.421 177.9C218.666 178.048 218.911 178.194 219.159 178.338C219.296 178.418 219.341 178.595 219.261 178.731C219.208 178.822 219.111 178.873 219.012 178.873ZM216.567 177.366C216.513 177.366 216.459 177.35 216.411 177.319C216.168 177.162 215.928 177.005 215.686 176.845C215.554 176.756 215.518 176.578 215.605 176.446C215.692 176.314 215.87 176.278 216.004 176.365C216.242 176.523 216.481 176.679 216.723 176.835C216.856 176.921 216.894 177.099 216.808 177.232C216.753 177.319 216.661 177.366 216.567 177.366ZM214.184 175.761C214.127 175.761 214.069 175.744 214.02 175.709C213.784 175.544 213.55 175.377 213.315 175.21C213.186 175.117 213.156 174.937 213.249 174.808C213.342 174.679 213.521 174.65 213.651 174.742C213.884 174.909 214.117 175.075 214.351 175.239C214.482 175.33 214.513 175.51 214.421 175.639C214.364 175.718 214.275 175.761 214.184 175.761ZM211.863 174.069C211.803 174.069 211.743 174.049 211.691 174.01C211.46 173.836 211.232 173.66 211.004 173.485C210.879 173.388 210.855 173.207 210.952 173.082C211.049 172.957 211.23 172.935 211.355 173.03C211.581 173.205 211.809 173.38 212.037 173.552C212.164 173.648 212.189 173.829 212.092 173.955C212.036 174.029 211.95 174.069 211.863 174.069ZM209.603 172.295C209.54 172.295 209.475 172.273 209.422 172.23C209.199 172.049 208.975 171.865 208.754 171.681C208.631 171.58 208.615 171.399 208.716 171.277C208.817 171.155 208.999 171.138 209.12 171.239C209.34 171.422 209.562 171.604 209.784 171.784C209.908 171.883 209.926 172.064 209.826 172.188C209.77 172.259 209.687 172.295 209.603 172.295ZM207.403 170.446C207.336 170.446 207.27 170.424 207.215 170.376C206.997 170.186 206.78 169.997 206.563 169.806C206.444 169.701 206.434 169.52 206.538 169.4C206.643 169.283 206.826 169.271 206.944 169.375C207.159 169.565 207.373 169.754 207.59 169.942C207.709 170.046 207.723 170.227 207.618 170.348C207.564 170.412 207.484 170.446 207.403 170.446ZM205.262 168.527C205.192 168.527 205.121 168.502 205.067 168.452C204.855 168.257 204.644 168.06 204.433 167.862C204.318 167.754 204.313 167.572 204.421 167.457C204.53 167.34 204.711 167.336 204.827 167.444C205.036 167.64 205.245 167.835 205.456 168.031C205.572 168.139 205.579 168.32 205.471 168.436C205.416 168.497 205.339 168.527 205.262 168.527ZM203.178 166.547C203.105 166.547 203.034 166.52 202.978 166.466C202.771 166.264 202.566 166.061 202.361 165.858C202.249 165.746 202.249 165.565 202.36 165.451C202.472 165.339 202.653 165.337 202.767 165.449C202.971 165.652 203.174 165.854 203.379 166.054C203.493 166.165 203.494 166.348 203.383 166.461C203.327 166.518 203.253 166.547 203.178 166.547ZM201.15 164.508C201.075 164.508 200.999 164.478 200.943 164.421C200.742 164.214 200.543 164.005 200.344 163.797C200.234 163.682 200.238 163.5 200.353 163.39C200.469 163.281 200.65 163.285 200.759 163.4C200.957 163.608 201.157 163.814 201.356 164.021C201.467 164.134 201.464 164.317 201.35 164.428C201.294 164.481 201.223 164.508 201.15 164.508ZM199.174 162.418C199.097 162.418 199.02 162.387 198.962 162.325C198.767 162.113 198.572 161.901 198.378 161.688C198.271 161.57 198.28 161.389 198.398 161.282C198.516 161.176 198.697 161.184 198.803 161.302C198.997 161.514 199.191 161.726 199.385 161.936C199.493 162.053 199.484 162.235 199.368 162.342C199.315 162.393 199.244 162.418 199.174 162.418ZM197.249 160.282C197.169 160.282 197.091 160.249 197.033 160.185C196.842 159.969 196.653 159.751 196.463 159.533C196.359 159.414 196.372 159.232 196.491 159.128C196.61 159.024 196.793 159.037 196.897 159.156C197.085 159.373 197.275 159.588 197.464 159.804C197.569 159.924 197.558 160.105 197.439 160.21C197.384 160.258 197.317 160.282 197.249 160.282ZM195.371 158.105C195.289 158.105 195.208 158.07 195.15 158.002C194.965 157.782 194.78 157.562 194.594 157.34C194.493 157.218 194.509 157.037 194.631 156.936C194.753 156.833 194.934 156.85 195.035 156.972C195.219 157.192 195.404 157.413 195.588 157.632C195.691 157.754 195.675 157.935 195.555 158.037C195.503 158.082 195.437 158.105 195.371 158.105ZM193.536 155.89C193.453 155.89 193.369 155.853 193.312 155.783C193.131 155.56 192.95 155.335 192.769 155.111C192.669 154.987 192.689 154.806 192.813 154.707C192.936 154.607 193.117 154.627 193.217 154.75C193.397 154.973 193.578 155.198 193.759 155.42C193.859 155.543 193.84 155.724 193.717 155.824C193.663 155.869 193.6 155.89 193.536 155.89ZM191.741 153.643C191.656 153.643 191.572 153.605 191.515 153.533C191.337 153.307 191.16 153.08 190.983 152.853C190.886 152.728 190.909 152.547 191.034 152.45C191.16 152.353 191.34 152.375 191.437 152.5C191.612 152.726 191.789 152.954 191.967 153.18C192.066 153.305 192.043 153.486 191.918 153.584C191.866 153.622 191.803 153.643 191.741 153.643ZM189.984 151.366C189.897 151.366 189.811 151.327 189.755 151.253C189.581 151.024 189.407 150.794 189.234 150.563C189.138 150.437 189.164 150.256 189.29 150.161C189.416 150.065 189.598 150.09 189.693 150.217C189.866 150.446 190.038 150.676 190.212 150.904C190.308 151.031 190.284 151.21 190.158 151.307C190.106 151.348 190.044 151.366 189.984 151.366ZM188.26 149.066C188.171 149.066 188.084 149.025 188.028 148.949C187.857 148.718 187.687 148.486 187.515 148.253C187.421 148.125 187.449 147.946 187.577 147.852C187.705 147.758 187.885 147.786 187.979 147.913C188.149 148.145 188.318 148.377 188.49 148.607C188.584 148.735 188.557 148.914 188.429 149.008C188.379 149.048 188.32 149.066 188.26 149.066ZM186.565 146.743C186.475 146.743 186.388 146.701 186.332 146.624L185.828 145.923C185.735 145.794 185.765 145.614 185.894 145.522C186.023 145.429 186.203 145.459 186.295 145.588L186.798 146.287C186.891 146.416 186.861 146.596 186.733 146.688C186.681 146.726 186.624 146.743 186.565 146.743ZM184.896 144.403C184.806 144.403 184.716 144.361 184.661 144.281L184.164 143.575C184.073 143.445 184.104 143.266 184.234 143.175C184.365 143.084 184.543 143.115 184.634 143.245L185.13 143.95C185.221 144.079 185.19 144.259 185.061 144.35C185.011 144.386 184.953 144.403 184.896 144.403ZM183.249 142.048C183.157 142.048 183.068 142.005 183.013 141.925L182.523 141.216C182.433 141.085 182.465 140.906 182.596 140.816C182.726 140.726 182.906 140.758 182.996 140.889L183.486 141.598C183.576 141.728 183.544 141.906 183.413 141.998C183.362 142.033 183.306 142.048 183.249 142.048ZM181.62 139.682C181.529 139.682 181.438 139.638 181.383 139.557L180.897 138.845C180.807 138.715 180.842 138.535 180.973 138.447C181.105 138.358 181.283 138.392 181.373 138.522L181.859 139.234C181.949 139.364 181.915 139.544 181.783 139.634C181.732 139.666 181.676 139.682 181.62 139.682ZM180.005 137.305C179.913 137.305 179.823 137.261 179.767 137.179L179.284 136.465C179.195 136.333 179.229 136.155 179.361 136.066C179.493 135.978 179.671 136.013 179.76 136.143L180.243 136.858C180.331 136.99 180.298 137.168 180.166 137.256C180.118 137.29 180.062 137.305 180.005 137.305ZM178.398 134.922C178.305 134.922 178.214 134.877 178.159 134.796L177.678 134.08C177.589 133.948 177.624 133.77 177.756 133.681C177.888 133.593 178.067 133.628 178.155 133.76L178.637 134.476C178.725 134.608 178.69 134.786 178.558 134.875C178.509 134.905 178.453 134.922 178.398 134.922ZM176.795 132.535C176.702 132.535 176.611 132.49 176.556 132.407L176.074 131.691C175.986 131.559 176.021 131.381 176.153 131.293C176.285 131.204 176.463 131.239 176.552 131.371L177.033 132.087C177.122 132.219 177.087 132.397 176.955 132.486C176.905 132.519 176.849 132.535 176.795 132.535ZM175.19 130.15C175.097 130.15 175.006 130.105 174.951 130.022L174.47 129.308C174.381 129.176 174.415 128.998 174.547 128.909C174.679 128.821 174.857 128.856 174.946 128.987L175.428 129.702C175.517 129.834 175.482 130.013 175.35 130.101C175.301 130.135 175.245 130.15 175.19 130.15ZM173.579 127.767C173.487 127.767 173.397 127.723 173.341 127.641L172.856 126.928C172.767 126.797 172.802 126.617 172.932 126.529C173.063 126.439 173.242 126.474 173.331 126.605L173.815 127.319C173.904 127.451 173.87 127.629 173.738 127.719C173.692 127.752 173.636 127.767 173.579 127.767ZM171.961 125.392C171.869 125.392 171.778 125.349 171.723 125.267L171.236 124.557C171.146 124.426 171.18 124.247 171.311 124.157C171.441 124.067 171.621 124.101 171.711 124.231L172.199 124.943C172.289 125.074 172.255 125.253 172.125 125.343C172.074 125.375 172.017 125.392 171.961 125.392ZM170.329 123.026C170.238 123.026 170.148 122.982 170.093 122.902L169.601 122.195C169.509 122.064 169.542 121.886 169.672 121.795C169.803 121.704 169.981 121.736 170.072 121.866L170.565 122.574C170.655 122.704 170.623 122.883 170.493 122.974C170.443 123.009 170.387 123.026 170.329 123.026ZM168.681 120.672C168.591 120.672 168.503 120.63 168.446 120.55L167.948 119.848C167.857 119.719 167.886 119.539 168.015 119.447C168.145 119.355 168.324 119.385 168.417 119.514L168.917 120.219C169.008 120.348 168.977 120.527 168.848 120.619C168.796 120.655 168.737 120.672 168.681 120.672ZM167.009 118.334C166.919 118.334 166.832 118.293 166.776 118.214L166.27 117.517C166.176 117.389 166.206 117.208 166.333 117.115C166.461 117.021 166.642 117.051 166.735 117.179L167.242 117.878C167.334 118.007 167.306 118.186 167.177 118.279C167.127 118.317 167.068 118.334 167.009 118.334ZM165.313 116.015C165.224 116.015 165.139 115.974 165.081 115.899L164.567 115.208C164.472 115.08 164.498 114.901 164.625 114.805C164.753 114.71 164.932 114.736 165.028 114.863L165.543 115.555C165.637 115.682 165.61 115.862 165.484 115.956C165.432 115.997 165.372 116.015 165.313 116.015ZM163.586 113.717C163.499 113.717 163.413 113.678 163.357 113.604C163.183 113.375 163.009 113.148 162.833 112.92C162.736 112.794 162.76 112.614 162.885 112.517C163.012 112.421 163.191 112.444 163.288 112.569C163.464 112.797 163.639 113.025 163.813 113.254C163.91 113.381 163.885 113.56 163.759 113.657C163.708 113.699 163.646 113.717 163.586 113.717ZM161.824 111.448C161.74 111.448 161.655 111.41 161.598 111.338C161.42 111.112 161.243 110.888 161.063 110.665C160.965 110.541 160.984 110.36 161.109 110.26C161.233 110.162 161.414 110.182 161.514 110.307C161.693 110.531 161.872 110.757 162.05 110.983C162.148 111.108 162.127 111.289 162.002 111.388C161.949 111.427 161.887 111.448 161.824 111.448ZM160.025 109.206C159.942 109.206 159.86 109.17 159.802 109.101C159.621 108.879 159.438 108.658 159.256 108.437C159.155 108.315 159.172 108.134 159.294 108.033C159.416 107.932 159.597 107.949 159.698 108.071C159.882 108.293 160.065 108.516 160.247 108.738C160.348 108.86 160.33 109.041 160.206 109.142C160.153 109.185 160.09 109.206 160.025 109.206ZM158.185 107C158.103 107 158.022 106.965 157.966 106.899C157.78 106.68 157.594 106.462 157.407 106.246C157.303 106.126 157.317 105.945 157.436 105.841C157.557 105.737 157.738 105.751 157.842 105.87C158.03 106.088 158.217 106.307 158.404 106.527C158.506 106.648 158.492 106.829 158.371 106.933C158.317 106.978 158.251 107 158.185 107ZM156.299 104.832C156.221 104.832 156.141 104.799 156.084 104.735C155.893 104.52 155.702 104.307 155.51 104.095C155.403 103.977 155.413 103.794 155.531 103.689C155.649 103.582 155.83 103.592 155.937 103.71C156.129 103.923 156.322 104.138 156.514 104.354C156.619 104.472 156.608 104.655 156.49 104.76C156.434 104.808 156.367 104.832 156.299 104.832ZM154.364 102.707C154.287 102.707 154.211 102.676 154.154 102.615C153.959 102.406 153.762 102.197 153.566 101.988C153.456 101.873 153.462 101.69 153.577 101.581C153.692 101.471 153.874 101.477 153.983 101.592C154.181 101.801 154.378 102.012 154.574 102.222C154.682 102.339 154.676 102.52 154.56 102.628C154.505 102.681 154.435 102.707 154.364 102.707ZM152.378 100.629C152.303 100.629 152.229 100.6 152.173 100.544C151.972 100.339 151.771 100.135 151.568 99.9318C151.455 99.8195 151.455 99.637 151.569 99.5247C151.681 99.4124 151.864 99.4138 151.976 99.5261C152.18 99.731 152.382 99.936 152.584 100.141C152.695 100.255 152.694 100.436 152.58 100.548C152.522 100.601 152.451 100.629 152.378 100.629ZM150.338 98.604C150.266 98.604 150.195 98.5773 150.138 98.524C149.932 98.3247 149.724 98.1268 149.516 97.9289C149.401 97.8194 149.397 97.6384 149.507 97.5233C149.616 97.4082 149.799 97.404 149.914 97.5134C150.123 97.7127 150.331 97.9121 150.539 98.1114C150.652 98.2222 150.657 98.4033 150.546 98.5184C150.488 98.5745 150.412 98.604 150.338 98.604ZM148.24 96.6362C148.171 96.6362 148.101 96.611 148.047 96.5618C147.835 96.3681 147.621 96.1759 147.408 95.985C147.29 95.8797 147.28 95.6972 147.385 95.5793C147.491 95.4614 147.673 95.4516 147.791 95.5569C148.006 95.7492 148.221 95.9429 148.434 96.1366C148.552 96.2432 148.56 96.4257 148.454 96.5422C148.396 96.6039 148.319 96.6362 148.24 96.6362ZM146.084 94.733C146.018 94.733 145.952 94.7105 145.897 94.6642C145.678 94.479 145.459 94.2937 145.239 94.1098C145.116 94.0088 145.101 93.8277 145.202 93.7056C145.303 93.5835 145.484 93.5667 145.606 93.6691C145.828 93.8544 146.05 94.0396 146.269 94.2277C146.39 94.3302 146.404 94.5126 146.301 94.6334C146.247 94.6993 146.165 94.733 146.084 94.733ZM143.861 92.907C143.798 92.907 143.736 92.8873 143.683 92.8452C143.458 92.667 143.232 92.4901 143.005 92.3147C142.88 92.2178 142.856 92.0368 142.954 91.9119C143.051 91.7856 143.232 91.7631 143.357 91.8599C143.586 92.0368 143.813 92.215 144.04 92.3947C144.164 92.4929 144.186 92.674 144.086 92.7989C144.03 92.8691 143.945 92.907 143.861 92.907ZM141.574 91.161C141.515 91.161 141.455 91.1427 141.404 91.1048C141.174 90.935 140.941 90.7666 140.708 90.5996C140.579 90.5069 140.549 90.3273 140.642 90.1981C140.735 90.069 140.914 90.0395 141.043 90.1322C141.278 90.3006 141.512 90.4704 141.744 90.6417C141.872 90.7357 141.9 90.9153 141.806 91.0431C141.75 91.1203 141.663 91.161 141.574 91.161ZM139.224 89.5006C139.168 89.5006 139.112 89.4851 139.062 89.4515C138.825 89.29 138.588 89.13 138.349 88.9728C138.217 88.8844 138.181 88.7062 138.268 88.5742C138.355 88.4423 138.533 88.4058 138.666 88.4928C138.907 88.6528 139.147 88.8128 139.385 88.9756C139.516 89.0655 139.551 89.2437 139.461 89.3757C139.406 89.4571 139.317 89.5006 139.224 89.5006ZM136.816 87.93C136.764 87.93 136.711 87.916 136.664 87.8865C136.422 87.7349 136.177 87.5847 135.933 87.4346C135.797 87.3517 135.755 87.1749 135.837 87.0402C135.92 86.904 136.097 86.8605 136.232 86.9447C136.479 87.0949 136.723 87.2465 136.969 87.3995C137.104 87.4837 137.145 87.6605 137.06 87.7953C137.006 87.8823 136.911 87.93 136.816 87.93ZM134.349 86.4535C134.301 86.4535 134.252 86.4408 134.207 86.4156C133.959 86.2738 133.71 86.1321 133.459 85.9931C133.32 85.9159 133.271 85.7405 133.348 85.6015C133.425 85.4626 133.601 85.4134 133.74 85.4906C133.991 85.631 134.243 85.7727 134.494 85.9159C134.631 85.9945 134.679 86.1699 134.601 86.3075C134.547 86.4015 134.45 86.4535 134.349 86.4535ZM131.828 85.0752C131.783 85.0752 131.738 85.0654 131.696 85.0429C131.442 84.911 131.187 84.7804 130.932 84.6513C130.79 84.5797 130.734 84.4071 130.806 84.2653C130.877 84.1236 131.05 84.0674 131.192 84.139C131.449 84.2695 131.705 84.4001 131.962 84.5334C132.103 84.6064 132.158 84.7804 132.085 84.9208C132.033 85.019 131.932 85.0752 131.828 85.0752ZM129.253 83.8022C129.212 83.8022 129.17 83.7937 129.131 83.7755C128.872 83.6534 128.613 83.5341 128.351 83.4162C128.207 83.3502 128.142 83.1804 128.208 83.0358C128.274 82.8913 128.444 82.8267 128.589 82.8927C128.851 83.012 129.114 83.1327 129.375 83.2548C129.518 83.3221 129.58 83.4934 129.512 83.6365C129.463 83.7404 129.361 83.8022 129.253 83.8022ZM126.626 82.6386C126.589 82.6386 126.551 82.6316 126.515 82.6162C126.251 82.5067 125.986 82.3986 125.72 82.2919C125.573 82.233 125.501 82.066 125.56 81.9186C125.619 81.7712 125.786 81.6996 125.934 81.7586C126.202 81.8653 126.469 81.9747 126.735 82.0856C126.881 82.1474 126.952 82.3144 126.89 82.4618C126.845 82.5727 126.738 82.6386 126.626 82.6386ZM123.95 81.5944C123.918 81.5944 123.884 81.5888 123.852 81.5775C123.583 81.4793 123.314 81.3838 123.044 81.2898C122.894 81.2379 122.815 81.0737 122.867 80.9235C122.919 80.7733 123.084 80.6933 123.234 80.7466C123.506 80.8421 123.779 80.9375 124.05 81.0372C124.198 81.0919 124.276 81.2561 124.221 81.4063C124.177 81.5214 124.066 81.5944 123.95 81.5944ZM121.228 80.6751C121.199 80.6751 121.17 80.6708 121.142 80.6624C120.868 80.5768 120.596 80.494 120.322 80.414C120.17 80.3691 120.083 80.2091 120.128 80.0575C120.173 79.9059 120.333 79.8189 120.485 79.8638C120.761 79.9452 121.038 80.0294 121.313 80.115C121.465 80.1628 121.549 80.3228 121.503 80.4743C121.465 80.5965 121.351 80.6751 121.228 80.6751ZM118.466 79.8905C118.442 79.8905 118.418 79.8877 118.394 79.8806C118.118 79.8091 117.84 79.7403 117.563 79.6729C117.409 79.6364 117.315 79.4806 117.351 79.3262C117.389 79.1719 117.545 79.0764 117.698 79.1143C117.979 79.1817 118.258 79.2519 118.537 79.3234C118.691 79.3627 118.783 79.5199 118.744 79.6729C118.71 79.8034 118.594 79.8905 118.466 79.8905ZM115.666 79.2462C115.648 79.2462 115.628 79.2448 115.609 79.2406C115.328 79.1845 115.049 79.1297 114.768 79.0778C114.612 79.0483 114.508 78.8996 114.538 78.7424C114.567 78.5866 114.714 78.4827 114.873 78.5122C115.157 78.5641 115.44 78.6203 115.724 78.6764C115.88 78.7073 115.981 78.8603 115.949 79.0147C115.92 79.1522 115.8 79.2462 115.666 79.2462ZM97.67 78.9824C97.5338 78.9824 97.4131 78.8855 97.3878 78.748C97.3583 78.5922 97.4622 78.442 97.6181 78.4125C97.9031 78.3592 98.1881 78.3087 98.4731 78.2624C98.6303 78.2343 98.7778 78.3424 98.803 78.4996C98.8283 78.6567 98.723 78.8041 98.5658 78.8294C98.285 78.8757 98.0028 78.9262 97.722 78.9782C97.7051 78.981 97.6883 78.9824 97.67 78.9824ZM112.836 78.7536C112.822 78.7536 112.808 78.7522 112.794 78.7508C112.512 78.7101 112.228 78.6708 111.944 78.6343C111.787 78.6146 111.676 78.4701 111.696 78.3129C111.716 78.1557 111.86 78.0462 112.017 78.0645C112.304 78.1009 112.59 78.1402 112.877 78.1823C113.034 78.2048 113.142 78.3508 113.12 78.508C113.1 78.6497 112.976 78.7536 112.836 78.7536ZM100.512 78.5501C100.368 78.5501 100.244 78.442 100.227 78.296C100.208 78.1388 100.321 77.9957 100.478 77.976C100.766 77.9423 101.054 77.9101 101.341 77.882C101.499 77.8694 101.64 77.9816 101.656 78.1402C101.671 78.2988 101.556 78.4392 101.398 78.4546C101.114 78.4827 100.829 78.5136 100.545 78.5473C100.534 78.5487 100.523 78.5501 100.512 78.5501ZM109.982 78.4195C109.973 78.4195 109.965 78.4195 109.956 78.4181C109.671 78.3929 109.388 78.3704 109.103 78.3508C108.944 78.3395 108.825 78.202 108.836 78.0434C108.847 77.8848 108.985 77.7697 109.142 77.7767C109.43 77.7964 109.719 77.8188 110.007 77.8455C110.166 77.8595 110.282 77.9985 110.268 78.1571C110.255 78.3073 110.129 78.4195 109.982 78.4195ZM103.376 78.3031C103.224 78.3031 103.098 78.1838 103.089 78.0308C103.081 77.8722 103.203 77.7374 103.36 77.7276C103.65 77.7122 103.939 77.6995 104.228 77.6897C104.394 77.6799 104.52 77.8076 104.526 77.9662C104.531 78.1248 104.408 78.2581 104.249 78.2638C103.964 78.2736 103.678 78.2862 103.393 78.3017C103.387 78.3031 103.381 78.3031 103.376 78.3031ZM107.113 78.2553C107.11 78.2553 107.108 78.2553 107.105 78.2553C106.82 78.2469 106.533 78.2427 106.248 78.2399C106.09 78.2385 105.962 78.1094 105.963 77.9494C105.965 77.7908 106.083 77.656 106.254 77.6644C106.543 77.6672 106.832 77.6729 107.122 77.6799C107.28 77.6841 107.405 77.816 107.401 77.9746C107.395 78.1318 107.268 78.2553 107.113 78.2553Z",
    fill: "url(#paint127_linear_4296_17492)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4296_17492",
    x1: 534.067,
    y1: 125.411,
    x2: 83.123,
    y2: 89.7696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4296_17492",
    x1: 66.8258,
    y1: 67.446,
    x2: 89.7298,
    y2: 67.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4296_17492",
    x1: 61.9042,
    y1: 117.195,
    x2: 87.3341,
    y2: 117.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4296_17492",
    x1: 211.543,
    y1: 158.559,
    x2: 215.758,
    y2: 158.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4296_17492",
    x1: 215.474,
    y1: 175.508,
    x2: 222.913,
    y2: 175.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4296_17492",
    x1: 202.321,
    y1: 177.746,
    x2: 210.902,
    y2: 177.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4296_17492",
    x1: 67.1027,
    y1: 95.6366,
    x2: 101.908,
    y2: 131.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4296_17492",
    x1: 13.2394,
    y1: 128.264,
    x2: 25.8212,
    y2: 128.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4296_17492",
    x1: 31.4075,
    y1: 202.098,
    x2: 37.3683,
    y2: 138.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4296_17492",
    x1: 29.5336,
    y1: 181.949,
    x2: 28.0297,
    y2: 197.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4296_17492",
    x1: 47.5933,
    y1: 203.627,
    x2: 53.554,
    y2: 140.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4296_17492",
    x1: 44.242,
    y1: 183.346,
    x2: 42.7381,
    y2: 199.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4296_17492",
    x1: 31.6133,
    y1: 81.3555,
    x2: 25.2982,
    y2: 111.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4296_17492",
    x1: 67.9406,
    y1: 62.9231,
    x2: 48.5656,
    y2: 71.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4296_17492",
    x1: 27.8347,
    y1: 97.4545,
    x2: 26.9671,
    y2: 83.4556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4296_17492",
    x1: 39.3578,
    y1: 129.436,
    x2: -26.7518,
    y2: 211.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#020039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#090056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4296_17492",
    x1: 288.861,
    y1: 111.511,
    x2: 284.791,
    y2: 116.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4296_17492",
    x1: 275.365,
    y1: 164.603,
    x2: 273.33,
    y2: 137.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4296_17492",
    x1: 276.094,
    y1: 151.302,
    x2: 277.06,
    y2: 159.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4296_17492",
    x1: 266.642,
    y1: 165.272,
    x2: 264.607,
    y2: 138.464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4042E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F52FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4296_17492",
    x1: 268.226,
    y1: 152.209,
    x2: 269.192,
    y2: 160.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4296_17492",
    x1: 273.958,
    y1: 96.7725,
    x2: 277.645,
    y2: 112.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4296_17492",
    x1: 257.193,
    y1: 97.5556,
    x2: 253.825,
    y2: 103.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4296_17492",
    x1: 236.232,
    y1: 160.234,
    x2: 242.681,
    y2: 149.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4296_17492",
    x1: 238.143,
    y1: 161.383,
    x2: 244.592,
    y2: 150.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEB3B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4296_17492",
    x1: 56.9337,
    y1: 87.5638,
    x2: 57.6925,
    y2: 87.5638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4296_17492",
    x1: 58.5238,
    y1: 85.1885,
    x2: 59.349,
    y2: 85.1885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4296_17492",
    x1: 60.2382,
    y1: 82.907,
    x2: 61.1283,
    y2: 82.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4296_17492",
    x1: 62.0787,
    y1: 80.7238,
    x2: 63.0315,
    y2: 80.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4296_17492",
    x1: 64.0313,
    y1: 78.6456,
    x2: 65.0445,
    y2: 78.6456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4296_17492",
    x1: 66.0899,
    y1: 76.6733,
    x2: 67.1612,
    y2: 76.6733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4296_17492",
    x1: 68.2503,
    y1: 74.8049,
    x2: 69.3771,
    y2: 74.8049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4296_17492",
    x1: 70.4997,
    y1: 73.0594,
    x2: 71.6798,
    y2: 73.0594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4296_17492",
    x1: 72.8326,
    y1: 71.4172,
    x2: 74.0636,
    y2: 71.4172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4296_17492",
    x1: 75.2381,
    y1: 69.881,
    x2: 76.5178,
    y2: 69.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4296_17492",
    x1: 77.7148,
    y1: 68.4646,
    x2: 79.0411,
    y2: 68.4646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4296_17492",
    x1: 80.2539,
    y1: 67.1494,
    x2: 81.6249,
    y2: 67.1494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4296_17492",
    x1: 82.84,
    y1: 65.9584,
    x2: 84.2537,
    y2: 65.9584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4296_17492",
    x1: 85.4806,
    y1: 64.8632,
    x2: 86.9352,
    y2: 64.8632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4296_17492",
    x1: 88.1683,
    y1: 63.8802,
    x2: 89.6558,
    y2: 63.8802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4296_17492",
    x1: 90.8902,
    y1: 62.9982,
    x2: 92.4035,
    y2: 62.9982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4296_17492",
    x1: 93.6508,
    y1: 62.2329,
    x2: 95.1873,
    y2: 62.2329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4296_17492",
    x1: 96.4335,
    y1: 61.569,
    x2: 97.9943,
    y2: 61.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4296_17492",
    x1: 99.2378,
    y1: 61.0064,
    x2: 100.82,
    y2: 61.0064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4296_17492",
    x1: 102.07,
    y1: 60.545,
    x2: 103.672,
    y2: 60.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4296_17492",
    x1: 104.91,
    y1: 60.1861,
    x2: 106.532,
    y2: 60.1861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4296_17492",
    x1: 107.765,
    y1: 59.935,
    x2: 109.405,
    y2: 59.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_4296_17492",
    x1: 110.628,
    y1: 59.7794,
    x2: 112.286,
    y2: 59.7794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_4296_17492",
    x1: 113.494,
    y1: 59.7334,
    x2: 115.167,
    y2: 59.7334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_4296_17492",
    x1: 116.364,
    y1: 59.7877,
    x2: 118.052,
    y2: 59.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_4296_17492",
    x1: 119.224,
    y1: 59.9362,
    x2: 120.926,
    y2: 59.9362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_4296_17492",
    x1: 122.083,
    y1: 60.2014,
    x2: 123.798,
    y2: 60.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_4296_17492",
    x1: 124.927,
    y1: 60.5603,
    x2: 126.654,
    y2: 60.5603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_4296_17492",
    x1: 127.763,
    y1: 61.0187,
    x2: 129.501,
    y2: 61.0187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_4296_17492",
    x1: 130.582,
    y1: 61.554,
    x2: 132.33,
    y2: 61.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_4296_17492",
    x1: 133.384,
    y1: 62.1754,
    x2: 135.143,
    y2: 62.1754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_4296_17492",
    x1: 136.172,
    y1: 62.87,
    x2: 137.931,
    y2: 62.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_4296_17492",
    x1: 138.939,
    y1: 63.6417,
    x2: 140.698,
    y2: 63.6417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_4296_17492",
    x1: 141.687,
    y1: 64.4913,
    x2: 143.444,
    y2: 64.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_4296_17492",
    x1: 144.411,
    y1: 65.4105,
    x2: 146.165,
    y2: 65.4105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_4296_17492",
    x1: 147.11,
    y1: 66.4076,
    x2: 148.863,
    y2: 66.4076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_4296_17492",
    x1: 149.786,
    y1: 67.451,
    x2: 151.537,
    y2: 67.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_4296_17492",
    x1: 152.437,
    y1: 68.564,
    x2: 154.185,
    y2: 68.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_4296_17492",
    x1: 155.068,
    y1: 69.7388,
    x2: 156.813,
    y2: 69.7388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_4296_17492",
    x1: 157.669,
    y1: 70.961,
    x2: 159.412,
    y2: 70.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_4296_17492",
    x1: 160.243,
    y1: 72.2359,
    x2: 161.984,
    y2: 72.2359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_4296_17492",
    x1: 162.791,
    y1: 73.5745,
    x2: 164.529,
    y2: 73.5745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_4296_17492",
    x1: 165.317,
    y1: 74.95,
    x2: 167.052,
    y2: 74.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_4296_17492",
    x1: 167.816,
    y1: 76.3659,
    x2: 169.549,
    y2: 76.3659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_4296_17492",
    x1: 170.298,
    y1: 77.8278,
    x2: 172.03,
    y2: 77.8278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_4296_17492",
    x1: 172.749,
    y1: 79.329,
    x2: 174.479,
    y2: 79.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_4296_17492",
    x1: 175.179,
    y1: 80.8669,
    x2: 176.908,
    y2: 80.8669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_4296_17492",
    x1: 177.587,
    y1: 82.4376,
    x2: 179.314,
    y2: 82.4376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_4296_17492",
    x1: 179.968,
    y1: 84.0465,
    x2: 181.694,
    y2: 84.0465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_4296_17492",
    x1: 182.334,
    y1: 85.6786,
    x2: 184.058,
    y2: 85.6786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_4296_17492",
    x1: 184.684,
    y1: 87.349,
    x2: 186.407,
    y2: 87.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_4296_17492",
    x1: 187.004,
    y1: 89.0282,
    x2: 188.727,
    y2: 89.0282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_4296_17492",
    x1: 189.313,
    y1: 90.7529,
    x2: 191.036,
    y2: 90.7529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_4296_17492",
    x1: 191.601,
    y1: 92.4924,
    x2: 193.323,
    y2: 92.4924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_4296_17492",
    x1: 193.874,
    y1: 94.2505,
    x2: 195.587,
    y2: 94.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_4296_17492",
    x1: 196.141,
    y1: 96.0322,
    x2: 197.844,
    y2: 96.0322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_4296_17492",
    x1: 198.392,
    y1: 97.8204,
    x2: 200.086,
    y2: 97.8204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_4296_17492",
    x1: 200.633,
    y1: 99.6321,
    x2: 202.318,
    y2: 99.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_4296_17492",
    x1: 202.863,
    y1: 101.459,
    x2: 204.54,
    y2: 101.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_4296_17492",
    x1: 205.082,
    y1: 103.285,
    x2: 206.752,
    y2: 103.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_4296_17492",
    x1: 207.296,
    y1: 105.12,
    x2: 208.958,
    y2: 105.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_4296_17492",
    x1: 209.509,
    y1: 106.969,
    x2: 211.164,
    y2: 106.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_4296_17492",
    x1: 211.712,
    y1: 108.819,
    x2: 213.361,
    y2: 108.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_4296_17492",
    x1: 213.917,
    y1: 110.668,
    x2: 215.56,
    y2: 110.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_4296_17492",
    x1: 216.125,
    y1: 112.516,
    x2: 217.763,
    y2: 112.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_4296_17492",
    x1: 218.324,
    y1: 114.365,
    x2: 219.957,
    y2: 114.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_4296_17492",
    x1: 220.531,
    y1: 116.213,
    x2: 222.16,
    y2: 116.213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_4296_17492",
    x1: 222.742,
    y1: 118.061,
    x2: 224.366,
    y2: 118.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_4296_17492",
    x1: 224.958,
    y1: 119.893,
    x2: 226.579,
    y2: 119.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_4296_17492",
    x1: 227.18,
    y1: 121.716,
    x2: 228.797,
    y2: 121.716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_4296_17492",
    x1: 229.415,
    y1: 123.532,
    x2: 231.03,
    y2: 123.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_4296_17492",
    x1: 231.659,
    y1: 125.332,
    x2: 233.271,
    y2: 125.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_4296_17492",
    x1: 233.914,
    y1: 127.123,
    x2: 235.524,
    y2: 127.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_4296_17492",
    x1: 236.176,
    y1: 128.9,
    x2: 237.784,
    y2: 128.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_4296_17492",
    x1: 238.452,
    y1: 130.644,
    x2: 240.058,
    y2: 130.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_4296_17492",
    x1: 240.753,
    y1: 132.382,
    x2: 242.348,
    y2: 132.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_4296_17492",
    x1: 243.071,
    y1: 134.088,
    x2: 244.654,
    y2: 134.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_4296_17492",
    x1: 245.403,
    y1: 135.763,
    x2: 246.975,
    y2: 135.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_4296_17492",
    x1: 247.761,
    y1: 137.423,
    x2: 249.322,
    y2: 137.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_4296_17492",
    x1: 250.137,
    y1: 139.044,
    x2: 251.687,
    y2: 139.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_4296_17492",
    x1: 252.534,
    y1: 140.645,
    x2: 254.075,
    y2: 140.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_4296_17492",
    x1: 254.957,
    y1: 142.193,
    x2: 256.491,
    y2: 142.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_4296_17492",
    x1: 257.422,
    y1: 143.689,
    x2: 258.951,
    y2: 143.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_4296_17492",
    x1: 259.921,
    y1: 145.098,
    x2: 261.448,
    y2: 145.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_4296_17492",
    x1: 262.472,
    y1: 146.427,
    x2: 263.996,
    y2: 146.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_4296_17492",
    x1: 265.074,
    y1: 147.642,
    x2: 266.599,
    y2: 147.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_4296_17492",
    x1: 267.742,
    y1: 148.728,
    x2: 269.267,
    y2: 148.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_4296_17492",
    x1: 270.461,
    y1: 149.657,
    x2: 271.987,
    y2: 149.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_4296_17492",
    x1: 273.231,
    y1: 150.419,
    x2: 274.754,
    y2: 150.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_4296_17492",
    x1: 276.057,
    y1: 150.979,
    x2: 277.576,
    y2: 150.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_4296_17492",
    x1: 278.918,
    y1: 151.306,
    x2: 280.418,
    y2: 151.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_4296_17492",
    x1: 281.806,
    y1: 151.392,
    x2: 283.278,
    y2: 151.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_4296_17492",
    x1: 284.69,
    y1: 151.174,
    x2: 286.124,
    y2: 151.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_4296_17492",
    x1: 287.538,
    y1: 150.643,
    x2: 288.925,
    y2: 150.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_4296_17492",
    x1: 290.321,
    y1: 149.818,
    x2: 291.653,
    y2: 149.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_4296_17492",
    x1: 293.004,
    y1: 148.72,
    x2: 294.27,
    y2: 148.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_4296_17492",
    x1: 295.559,
    y1: 147.325,
    x2: 296.749,
    y2: 147.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_4296_17492",
    x1: 297.95,
    y1: 145.665,
    x2: 299.05,
    y2: 145.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_4296_17492",
    x1: 300.12,
    y1: 143.722,
    x2: 301.114,
    y2: 143.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_4296_17492",
    x1: 302.009,
    y1: 141.505,
    x2: 302.878,
    y2: 141.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_4296_17492",
    x1: 303.564,
    y1: 139.041,
    x2: 304.286,
    y2: 139.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_4296_17492",
    x1: 304.707,
    y1: 136.379,
    x2: 305.265,
    y2: 136.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_4296_17492",
    x1: 97.383,
    y1: 132.415,
    x2: 268.737,
    y2: 132.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE3FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlterationEmpty);
export default __webpack_public_path__ + "static/media/AlterationEmpty.12a4243d63d05d6ee6bc826e02cdbb38.svg";
export { ForwardRef as ReactComponent };